
// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { FaChevronUp, FaChevronDown } from "react-icons/fa";
// import { MdContentCopy } from "react-icons/md";

// // Import CSS files
// import "../Dashboard Style/core.css";
// import "../Dashboard Style/flatpickr.min.css";
// import "../assets1/css/custom.css";
// import "../assets1/css/style.css";

// // Import images
// import logo from "../assets1/images/logo.webp";
// import usFlag from "../assets1/images/flags/us.svg";
// import frFlag from "../assets1/images/flags/fr.svg";
// import face2 from "../assets1/images/faces/face2.webp";
// import face3 from "../assets1/images/faces/face3.webp";
// import face4 from "../assets1/images/faces/face4.webp";
// import face5 from "../assets1/images/faces/face5.webp";
// import face6 from "../assets1/images/faces/face6.webp";
// import qrCodeImage from "../assets/images/qr-code.jpeg";
// import { setActiveDate, setPaymentSubmitted } from "../Redux/user_information";
// import Sidebar from "./Core/Sidebar";
// import Navbar from "./Core/Navbar";

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);
//   console.log("userData : ", userData)
//   const hasSubmittedPayment = useSelector((state) => state.user?.hasSubmittedPayment);
//   const userActiveDate = userData?.active_date;

//   console.log("authToken : ", authToken);
//   console.log("hasSubmittedPayment : ", hasSubmittedPayment);
//   console.log("userActiveDate : ", userActiveDate);

//   const [showPaymentPopup, setShowPaymentPopup] = useState(false);
//   const [showActivationPopup, setShowActivationPopup] = useState(false);
//   const [transferHash, setTransferHash] = useState("");
//   const [isProcessing, setIsProcessing] = useState(false);

//   // State for sidebar and dropdowns
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [openDropdowns, setOpenDropdowns] = useState({});

//   console.log("userData : ", userData)

//   // Wallet data - using Redux values for first 3, static for last 2
//   const walletData = {
//     quantumMainVault: userData?.wallets?.main_wallet || 0,
//     quantumRelease: userData?.wallets?.release_wallet || 0,
//     quantumCurrent: userData?.wallets?.current_wallet || 0,
//     quantumQiAirdrop: 0, // Static value
//     totalReferrals: userData?.referral_count
//   };

//   // const sponsorLinks = [
//   //   {
//   //     id: 1,
//   //     name: "Sponsor ID",
//   //     link: "http://localhost:3000/register?sponsor_code=WQ13242514",
//   //     icon: "user-plus"
//   //   },
//   //   {
//   //     id: 2,
//   //     name: "Position Left",
//   //     link: "http://localhost:3000/register?placement_code=WQ13242514&position=Left",
//   //     icon: "arrow-left"
//   //   },
//   //   {
//   //     id: 3,
//   //     name: "Position Right",
//   //     link: "http://localhost:3000/register?placement_code=WQ13242514&position=Right",
//   //     icon: "arrow-right"
//   //   }
//   // ];


//   // Generate referral links

//   const sponsorLinks = [
//     {
//       id: 1,
//       name: "Sponsor ID",
//       link: `https://home.oceaniabloom9.com/register?sponsor_code=${userData.user_code}`,
//       icon: "user-plus"
//     },
//     {
//       id: 2,
//       name: "Position Left",
//       link: `https://home.oceaniabloom9.com/register?placement_code=${userData.user_code}&position=Left`,
//       icon: "arrow-left"
//     },
//     {
//       id: 3,
//       name: "Position Right",
//       link: `https://home.oceaniabloom9.com/register?placement_code=${userData.user_code}&position=Right`,
//       icon: "arrow-right"
//     }
//   ];

//   const generateReferralLinks = () => {
//     const baseUrl = "https://global.thewillowquantum.com/register";
//     const sponsorCode = "WQ13242514"; // This should come from userData

//     return {
//       sponsorLink: `${baseUrl}?placement_code=${sponsorCode}`,
//       positionLeft: `${baseUrl}?placement_code=${sponsorCode}-position-left`,
//       positionRight: `${baseUrl}?placement_code=${sponsorCode}-position-right`
//     };
//   };

//   const referralLinks = generateReferralLinks();

//   // Add this function near your other API functions
//   const handleActivateSelfByWallet = async () => {
//     try {
//       setIsProcessing(true);

//       const response = await fetch(`https://global.thewillowquantum.com/api/user/active-self-by-wallet`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//           'Authorization': `Bearer ${authToken}`,
//         },
//         body: new URLSearchParams({
//           // Add any required parameters here if needed
//           // Based on the image, it might not need any body parameters
//         })
//       });

//       const data = await response.json();

//       if (data.status) {
//         // Activation successful
//         dispatch(setPaymentSubmitted());
//         const currentDate = new Date().toISOString().split('T')[0];
//         dispatch(setActiveDate(currentDate));
//         showNotification("Account activated successfully using wallet balance!", "success");
//         setShowPaymentPopup(false);
//       } else {
//         showNotification(data.message || "Activation failed. Please try again.", "error");
//       }
//     } catch (error) {
//       console.error('Error activating by wallet:', error);
//       showNotification("Failed to activate account. Please try again.", "error");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // Update the handleWalletSubmit function
//   const handleWalletSubmit = (e) => {
//     e.preventDefault();

//     if (!hasSufficientBalance) {
//       showNotification("Insufficient wallet balance. Please add funds.", "error");
//       return;
//     }

//     if (window.confirm(`Confirm registration payment of $${requiredAmount} from your wallet?`)) {
//       handleActivateSelfByWallet();
//     }
//   };

//   // Toggle sidebar
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Toggle dropdown
//   const toggleDropdown = (dropdownId) => {
//     setOpenDropdowns(prev => ({
//       ...prev,
//       [dropdownId]: !prev[dropdownId]
//     }));
//   };

//   // Initialize sidebar functionality
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');

//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }

//     // Add custom scrollbar to sidebar body
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Show payment popup only if payment hasn't been submitted
//     if (!hasSubmittedPayment) {
//       setShowPaymentPopup(true);
//     }

//     // Show activation popup if active_date is null
//     if (!userActiveDate) {
//       setShowActivationPopup(true);
//     }

//     // Initialize all dropdowns as closed by default
//     const initialDropdownState = {
//       dashboard: false,
//       fundManagement: false,
//       registrationTeam: false,
//       incomeEarnings: false,
//       bonanzaRewards: false,
//       airdrop: false,
//       withdrawal: false,
//       settings: false
//     };
//     setOpenDropdowns(initialDropdownState);
//   }, [hasSubmittedPayment, userActiveDate]);

//   useEffect(() => {
//     // Add custom scrollbar styles
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }

//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }

//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }

//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }

//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }

//       /* Custom scrollbar for modal */
//       .modal-body {
//         max-height: 70vh;
//         overflow-y: auto;
//       }

//       .modal-body::-webkit-scrollbar {
//         width: 8px;
//       }

//       .modal-body::-webkit-scrollbar-track {
//         background: #f1f1f1;
//         border-radius: 10px;
//       }

//       .modal-body::-webkit-scrollbar-thumb {
//         background: #888;
//         border-radius: 10px;
//       }

//       .modal-body::-webkit-scrollbar-thumb:hover {
//         background: #555;
//       }

//       /* Notification styles */
//       .notification {
//         animation: slideIn 0.3s ease-out;
//         position: fixed;
//         top: 20px;
//         right: 20px;
//         z-index: 9999;
//         min-width: 300px;
//       }

//       @keyframes slideIn {
//         from {
//           transform: translateX(100%);
//           opacity: 0;
//         }
//         to {
//           transform: translateX(0);
//           opacity: 1;
//         }
//       }

//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }

//       .modal {
//         transition: opacity 0.3s ease;
//       }

//       /* Adjust column width for 4 boxes in a row */
//       .col-md-4 {
//         width: 25%;
//         flex: 0 0 25%;
//         max-width: 25%;
//       }

//       /* Single box below takes full width */
//       .col-md-12-single {
//         width: 100%;
//         flex: 0 0 100%;
//         max-width: 100%;
//       }

//       @media (max-width: 1200px) {
//         .col-md-4 {
//           width: 50%;
//           flex: 0 0 50%;
//           max-width: 50%;
//         }
//       }

//       @media (max-width: 768px) {
//         .col-md-4 {
//           width: 100%;
//           flex: 0 0 100%;
//           max-width: 100%;
//         }
//       }

//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }

//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }

//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }

//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }

//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }

//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }

//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }

//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }

//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }

//       /* Box styling */
//       .custom-card {
//         position: relative;
//         border-radius: 10px;
//         overflow: hidden;
//         background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
//         border: 1px solid #e9ecef;
//         transition: all 0.3s ease;
//       }

//       .custom-card:hover {
//         transform: translateY(-5px);
//         box-shadow: 0 10px 20px rgba(0,0,0,0.1);
//       }

//       .custom-card .top-left,
//       .custom-card .top-right,
//       .custom-card .bottom-left,
//       .custom-card .bottom-right {
//         position: absolute;
//         width: 20px;
//         height: 20px;
//         border-color: var(--primary-color, #0d6efd);
//       }

//       .custom-card .top-left {
//         top: 0;
//         left: 0;
//         border-top: 2px solid;
//         border-left: 2px solid;
//       }

//       .custom-card .top-right {
//         top: 0;
//         right: 0;
//         border-top: 2px solid;
//         border-right: 2px solid;
//       }

//       .custom-card .bottom-left {
//         bottom: 0;
//         left: 0;
//         border-bottom: 2px solid;
//         border-left: 2px solid;
//       }

//       .custom-card .bottom-right {
//         bottom: 0;
//         right: 0;
//         border-bottom: 2px solid;
//         border-right: 2px solid;
//       }

//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }

//       /* Year Planner Table Styles */
//       .year-planner-table {
//         width: 100%;
//         border-collapse: collapse;
//         margin-top: 20px;
//         font-size: 12px;
//       }

//       .year-planner-table th {
//         background-color: #f8f9fa;
//         border: 1px solid #dee2e6;
//         padding: 8px;
//         text-align: center;
//         font-weight: 600;
//       }

//       .year-planner-table td {
//         border: 1px solid #dee2e6;
//         padding: 8px;
//         text-align: center;
//         height: 40px;
//         vertical-align: middle;
//       }

//       .year-planner-table .day-header {
//         background-color: #e9ecef;
//         font-weight: 600;
//         width: 80px;
//       }

//       .year-planner-table .month-header {
//         background-color: #0d6efd;
//         color: white;
//       }

//       .year-planner-table tr:hover td {
//         background-color: #f8f9fa;
//       }

//       /* Referral Links Card Styles */
//       .referral-link-card {
//         margin-bottom: 10px;
//       }

//       .referral-link-input {
//         font-size: 12px;
//         font-family: 'Courier New', monospace;
//       }

//       .copy-btn {
//         min-width: 70px;
//       }

//       /* Activation Popup Styles */
//       .activation-popup {
//         background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//         color: white;
//         border-radius: 10px;
//         overflow: hidden;
//       }

//       .activation-icon {
//         font-size: 4rem;
//         color: #ffd700;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   const handleSubmitPayment = async (e) => {
//     e.preventDefault();

//     if (!transferHash.trim()) {
//       showNotification("Please enter transfer hash", "error");
//       return;
//     }

//     setIsProcessing(true);

//     try {
//       // Create FormData object
//       const formData = new FormData();
//       formData.append('hash_id', transferHash);

//       const response = await fetch(`https://global.thewillowquantum.com/api/user/register-payment`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: formData
//       });

//       const result = await response.json();

//       if (response.ok) {
//         if (result.success) {
//           // IMPORTANT: Dispatch action to mark payment as submitted
//           dispatch(setPaymentSubmitted());

//           showNotification("Payment submitted successfully!", "success");
//           setTransferHash("");
//           setShowPaymentPopup(false);

//           showNotification(`Transaction ID: ${result.transaction_id || result.data?.transactionId || result.id}`, "info");
//         } else {
//           showNotification(result.message || "Payment submission failed. Please try again.", "error");
//         }
//       } else {
//         // Handle HTTP errors
//         if (response.status === 401) {
//           showNotification("Session expired. Please log in again.", "error");
//           navigate('/signin');
//         } else if (response.status === 400) {
//           showNotification(result.message || "Invalid request. Please check your input.", "error");
//         } else if (response.status === 422) {
//           showNotification(result.message || "Validation error. Please check your input.", "error");
//         } else {
//           showNotification(result.message || "Server error. Please try again later.", "error");
//         }
//       }
//     } catch (error) {
//       console.error("Payment submission error:", error);
//       showNotification("Network error. Please check your connection and try again.", "error");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const handleCopyToClipboard = (text, label) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         showNotification(`${label} copied to clipboard!`, "success");
//       })
//       .catch(err => {
//         console.error("Failed to copy: ", err);
//         showNotification("Failed to copy to clipboard", "error");
//       });
//   };

//   const handleCopyAddress = () => {
//     const address = "0xf22380424e0dfc7170b484d8833dc737d0957c53";
//     handleCopyToClipboard(address, "Address");
//   };

//   const handleClosePopup = () => {
//     setShowPaymentPopup(false);
//   };

//   const handleCloseActivationPopup = () => {
//     setShowActivationPopup(false);
//   };

//   const handleActivateAccount = () => {
//     // Here you would make an API call to activate the account
//     // For now, we'll just simulate activation
//     const currentDate = new Date().toISOString().split('T')[0];

//     // Dispatch action to update active_date
//     dispatch(setActiveDate(currentDate));

//     showNotification("Account activated successfully!", "success");
//     setShowActivationPopup(false);

//     // In a real app, you would make an API call here
//     // Example:
//     // fetch(`https://global.thewillowquantum.com/api/user/activate-account`, {
//     //   method: 'POST',
//     //   headers: {
//     //     'Authorization': `Bearer ${authToken}`,
//     //     'Content-Type': 'application/json',
//     //   },
//     //   body: JSON.stringify({ activation_date: currentDate })
//     // })
//   };

//   const showNotification = (message, type = "info") => {
//     // Create notification element
//     const notification = document.createElement('div');
//     notification.className = `notification alert alert-${type === 'error' ? 'danger' : type} alert-dismissible fade show`;
//     notification.innerHTML = `
//       <div class="d-flex align-items-center">
//         <i data-lucide="${type === 'success' ? 'check-circle' : type === 'error' ? 'alert-circle' : 'info'}" class="me-2"></i>
//         <span>${message}</span>
//         <button type="button" class="btn-close ms-auto" data-bs-dismiss="alert"></button>
//       </div>
//     `;

//     // Add to body
//     document.body.appendChild(notification);

//     // Auto remove after 5 seconds
//     setTimeout(() => {
//       if (notification.parentNode) {
//         notification.remove();
//       }
//     }, 5000);
//   };

//   // Year Planner Table Component (as shown in your image)
//   const YearPlannerTable = () => {
//     const months = ['JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER'];
//     const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
//     const rows = 18; // As shown in your image

//     return (
//       <div className="card custom-card mt-4">
//         <div className="top-left"></div>
//         <div className="top-right"></div>
//         <div className="bottom-left"></div>
//         <div className="bottom-right"></div>
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-baseline mb-3">
//             <h6 className="card-title mb-0">
//               <i className="me-2" data-lucide="calendar"></i>
//               YEAR PLANNER
//             </h6>
//           </div>

//           <div className="table-responsive">
//             <table className="year-planner-table">
//               <thead>
//                 <tr>
//                   <th className="day-header">DAY</th>
//                   {months.map((month, index) => (
//                     <th key={index} className="month-header">{month}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {Array.from({ length: rows }).map((_, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="day-header">{days[rowIndex % days.length]}</td>
//                     {months.map((month, monthIndex) => (
//                       <td key={monthIndex}></td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="mt-4">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="d-flex align-items-center mb-2">
//                   <i className="me-2" data-lucide="user" style={{ color: '#0d6efd' }}></i>
//                   <span className="fw-bold">Semper Id</span>
//                 </div>
//                 <div className="d-flex align-items-center mb-1">
//                   <span className="text-muted small me-2">placements - left</span>
//                   <i className="me-2" data-lucide="arrow-left" style={{ color: '#28a745' }}></i>
//                 </div>
//                 <div className="d-flex align-items-center mb-1">
//                   <span className="text-muted small me-2">placement - right</span>
//                   <i className="me-2" data-lucide="arrow-right" style={{ color: '#dc3545' }}></i>
//                 </div>
//                 <div className="d-flex align-items-center">
//                   <span className="text-muted small me-2">p</span>
//                   <i className="me-2" data-lucide="circle" style={{ color: '#ffc107' }}></i>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const SponsorLinksTable = () => {
//     return (
//       <div className="card custom-card mt-4">
//         <div className="top-left"></div>
//         <div className="top-right"></div>
//         <div className="bottom-left"></div>
//         <div className="bottom-right"></div>
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-baseline mb-3">
//             <h6 className="card-title mb-0 text-white">
//               <i className="me-2" data-lucide="link"></i>
//               Sponsor Links
//             </h6>
//           </div>

//           <div className="table-responsive">
//             <table className="sponsor-links-table table">
//               <thead>
//                 <tr className="border-bottom border-secondary">
//                   <th className="text-white fw-medium" style={{ width: '70%' }}>Link Name</th>
//                   <th className="text-white fw-medium" style={{ width: '30%' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {sponsorLinks.map((link) => (
//                   <tr key={link.id} className="border-bottom border-secondary">
//                     <td className="py-3">
//                       <div className="sponsor-link-cell d-flex align-items-center">
//                         <i className={`text-white me-2`} data-lucide={link.icon}></i>
//                         <span className="fw-medium text-white">{link.name}</span>
//                       </div>
//                     </td>
//                     <td className="py-3">
//                       <button
//                         className="btn btn-outline-light btn-sm copy-btn-small"
//                         onClick={() => handleCopyToClipboard(link.link, link.name)}
//                         type="button"
//                       >
//                         {/* <i className="me-1" data-lucide="copy"></i> Copy */}
//                         <MdContentCopy />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };
//   const [paymentMethod, setPaymentMethod] = useState('hash'); // 'hash' or 'wallet'
//   const currentWalletBalance = userData?.main_wallet || 0;
//   const requiredAmount = 5;
//   const hasSufficientBalance = currentWalletBalance >= requiredAmount;
//   const PaymentPopup = () => {
//     // Don't show if payment has been submitted or if user already has active_date
//     if (!showPaymentPopup || hasSubmittedPayment || userActiveDate) return null;


//     const handleWalletSubmit = (e) => {
//       e.preventDefault();

//       if (!hasSufficientBalance) {
//         showNotification("Insufficient wallet balance. Please add funds.", "error");
//         return;
//       }

//       if (window.confirm(`Confirm registration payment of $${requiredAmount} from your wallet?`)) {
//         // Handle wallet payment logic here
//         console.log('Wallet payment initiated');

//         // Simulate API call
//         setIsProcessing(true);
//         setTimeout(() => {
//           setIsProcessing(false);
//           dispatch(setPaymentSubmitted());
//           const currentDate = new Date().toISOString().split('T')[0];
//           dispatch(setActiveDate(currentDate));
//           showNotification("Registration completed successfully using wallet balance!", "success");
//           setShowPaymentPopup(false);
//         }, 1500);
//       }
//     };

//     return (
//       <div className="modal-backdrop show d-block" style={{
//         backgroundColor: 'rgba(0,0,0,0.7)',
//         backdropFilter: 'blur(3px)'
//       }}>
//         <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
//           <div className="modal-dialog modal-dialog-centered modal-lg">
//             <div className="modal-content border-0 shadow-lg">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title mb-0 d-flex align-items-center">
//                   <i className="me-2" data-lucide="credit-card"></i>
//                   Registration Payment Required
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={handleClosePopup}
//                 ></button>
//               </div>
//               <div className="modal-body p-4">
//                 {/* Payment Method Toggle */}
//                 <div className="payment-method-toggle mb-4">
//                   <div className="toggle-buttons d-flex bg-light rounded p-1">
//                     <button
//                       className={`toggle-btn1 flex-fill ${paymentMethod === 'hash' ? 'active' : ''}`}
//                       onClick={() => setPaymentMethod('hash')}
//                     >
//                       <i className="me-2" data-lucide="hash"></i>
//                       Active via Hash
//                     </button>
//                     <button
//                       className={`toggle-btn1 flex-fill ${paymentMethod === 'wallet' ? 'active' : ''}`}
//                       onClick={() => setPaymentMethod('wallet')}
//                     >
//                       <i className="me-2" data-lucide="wallet"></i>
//                       Active via Wallet
//                     </button>
//                   </div>
//                 </div>

//                 {/* Payment Method Indicator */}
//                 <div className="alert alert-info mb-4">
//                   <div className="d-flex align-items-center">
//                     <i className="me-2" data-lucide={paymentMethod === 'hash' ? 'hash' : 'wallet'}></i>
//                     <div>
//                       <h6 className="mb-1">{paymentMethod === 'hash' ? 'Hash Payment Method' : 'Wallet Payment Method'}</h6>
//                       <p className="mb-0 small">
//                         {paymentMethod === 'hash'
//                           ? 'Submit your transaction hash to verify payment'
//                           : 'Use your wallet balance to complete registration'}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Hash Payment Method (Already Done) */}
//                 {paymentMethod === 'hash' && (
//                   <div className="payment-details">
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="card border-primary">
//                           <div className="card-header bg-primary text-white">
//                             <h6 className="mb-0">Registration Fees</h6>
//                           </div>
//                           <div className="card-body">
//                             <div className="row">
//                               <div className="col-md-8">
//                                 <h5 className="text-primary mb-2">Willow Quantum</h5>
//                                 <div className="d-flex align-items-center mb-3">
//                                   <i className="me-2" data-lucide="coin" style={{ color: '#00a478' }}></i>
//                                   <span className="fw-bold">USDT (BEP20)</span>
//                                 </div>

//                                 <div className="mb-3">
//                                   <label className="form-label text-muted small mb-1">Receiving Address</label>
//                                   <div className="input-group">
//                                     <input
//                                       type="text"
//                                       className="form-control bg-light referral-link-input"
//                                       value="0xf22380424e0dfc7170b484d8833dc737d0957c53"
//                                       readOnly
//                                     />
//                                     <button
//                                       className="btn btn-outline-primary copy-btn"
//                                       onClick={handleCopyAddress}
//                                       type="button"
//                                     >
//                                       <i className="me-1" data-lucide="copy"></i> Copy
//                                     </button>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="col-md-4">
//                                 <div className="text-center">
//                                   <div className="card bg-light">
//                                     <div className="qr-placeholder bg-white rounded">
//                                       <img
//                                         src={qrCodeImage}
//                                         alt="Payment QR Code"
//                                         style={{
//                                           width: "100%",
//                                           objectFit: 'contain'
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                   <p className="text-muted small mt-2 mb-0">Scan QR Code</p>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="alert alert-success">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div>
//                               <h5 className="mb-1">Fixed Payment Amount</h5>
//                               <h2 className="text-dark mb-0">$5 USD</h2>
//                             </div>
//                             <div className="text-end">
//                               <div className="badge bg-primary fs-6">Already Done</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <form onSubmit={handleSubmitPayment}>
//                       <div className="mb-4">
//                         <label htmlFor="transferHash" className="form-label fw-bold">
//                           <i className="me-2" data-lucide="hash"></i>
//                           Transaction Hash / TXID
//                         </label>
//                         <input
//                           type="text"
//                           className="form-control form-control-lg referral-link-input"
//                           id="transferHash"
//                           placeholder="Enter your transaction hash"
//                           value={transferHash}
//                           onChange={(e) => setTransferHash(e.target.value)}
//                           required
//                         />
//                       </div>

//                       <div className="d-grid gap-2">
//                         <button
//                           type="submit"
//                           className="btn btn-primary btn-lg py-3"
//                           disabled={isProcessing}
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center"
//                           }}
//                         >
//                           {isProcessing ? (
//                             <>
//                               <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                               Processing Payment...
//                             </>
//                           ) : (
//                             <>
//                               <i className="me-2" data-lucide="check-circle"></i>
//                               Submit Payment Verification
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 )}

//                 {/* Wallet Payment Method */}
//                 {/* Wallet Payment Method */}
//                 {paymentMethod === 'wallet' && (
//                   <div className="wallet-payment-details">
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="alert alert-warning">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div>
//                               <h5 className="mb-1">Registration Fees Required</h5>
//                               <h2 className="text-dark mb-0">$5 USD</h2>
//                             </div>
//                             <div className="text-end">
//                               <div className="badge bg-warning fs-6">Required Amount</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     {/* Current Wallet Balance */}
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className="card border-success">
//                           <div className="card-header bg-success text-white">
//                             <h6 className="mb-0 d-flex align-items-center">
//                               <i className="me-2" data-lucide="wallet"></i>
//                               Current wallet amount
//                             </h6>
//                           </div>
//                           <div className="card-body">
//                             <div className="text-center py-4">
//                               <div className="display-1 fw-bold text-success mb-2">
//                                 ${currentWalletBalance.toFixed(2)}
//                               </div>
//                               <p className="text-muted mb-0">Available for registration payment</p>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>



//                     {/* Register Free */}
//                     {/* <div className="row mb-4">
//       <div className="col-12">
//         <div className="card border-info">
//           <div className="card-header bg-info text-white">
//             <h6 className="mb-0 d-flex align-items-center">
//               <i className="me-2" data-lucide="gift"></i>
//               Register Free
//             </h6>
//           </div>
//           <div className="card-body">
//             <div className="text-center">
//               <h4 className="text-info mb-3">→ $5</h4>
//               <p className="mb-2">
//                 If wallet → $5 and greater then
//               </p>
//               <div className={`mt-3 ${hasSufficientBalance ? 'text-success' : 'text-danger'}`}>
//                 <i className="me-2" data-lucide={hasSufficientBalance ? 'check-circle' : 'x-circle'}></i>
//                 {hasSufficientBalance 
//                   ? `Your balance ($${currentWalletBalance.toFixed(2)}) is sufficient` 
//                   : `You need $${(requiredAmount - currentWalletBalance).toFixed(2)} more`}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div> */}

//                     {/* Balance Status */}
//                     <div className="row mb-4">
//                       <div className="col-12">
//                         <div className={`balance-status-card ${hasSufficientBalance ? 'bg-success' : 'bg-danger'}`}>
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div className="d-flex align-items-center">
//                               {/* <div className={`status-icon ${hasSufficientBalance ? 'text-success' : 'text-danger'}`}>
//                 <i data-lucide={hasSufficientBalance ? 'check-circle' : 'alert-circle'}></i>
//               </div> */}
//                               <div className="ms-3">
//                                 <h6 className="mb-1">
//                                   {hasSufficientBalance ? 'Sufficient Balance ✓' : 'Insufficient Balance ✗'}
//                                 </h6>
//                                 <p className="mb-0 small">
//                                   {hasSufficientBalance
//                                     ? `Your wallet has $${currentWalletBalance.toFixed(2)}, which meets the $${requiredAmount} requirement`
//                                     : `You need $${(requiredAmount - currentWalletBalance).toFixed(2)} more to proceed`}
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Submit Button - Only show if sufficient balance */}
//                     {hasSufficientBalance && (
//                       <form onSubmit={handleWalletSubmit}>
//                         <div className="d-grid gap-2">
//                           <button
//                             type="submit"
//                             className="btn btn-success btn-lg py-3"
//                             disabled={isProcessing}
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center"
//                             }}
//                           >
//                             {isProcessing ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                                 Processing Activation...
//                               </>
//                             ) : (
//                               <>
//                                 <i className="me-2" data-lucide="check-circle"></i>
//                                 Activate Account via Wallet
//                               </>
//                             )}
//                           </button>
//                         </div>
//                       </form>
//                     )}

//                     {/* Insufficient Balance Message */}
//                     {/* {!hasSufficientBalance && (
//       <div className="insufficient-balance-message">
//         <div className="alert alert-danger">
//           <div className="d-flex align-items-center">
//             <i className="me-3" data-lucide="alert-circle"></i>
//             <div>
//               <h6 className="mb-1">Insufficient Balance</h6>
//               <p className="mb-0">
//                 You need <strong>${(requiredAmount - currentWalletBalance).toFixed(2)}</strong> more in your wallet.
//                 Please use the "Hash Payment" method or add funds to your wallet.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="text-center mt-3">
//           <button
//             className="btn btn-outline-primary"
//             onClick={() => setPaymentMethod('hash')}
//           >
//             <i className="me-2" data-lucide="hash"></i>
//             Switch to Hash Payment
//           </button>
//         </div>
//       </div>
//     )} */}
//                   </div>
//                 )}
//               </div>


//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <>
//       <PaymentPopup />


//       <div className="main-wrapper">
//         {/* Sidebar with custom scrollbar */}
//         <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//           <div className="sidebar-header">
//             <a href="#" className="sidebar-brand">
//               <i className="me-2" data-lucide="atom"></i>
//               Willow <span>Quantum</span>
//             </a>
//             <div className="sidebar-toggler" onClick={toggleSidebar}>
//               <span></span>
//               <span></span>
//               <span></span>
//             </div>
//           </div>
//           <Sidebar />
//         </nav>

//         <div className="page-wrapper">
//           {/* Navbar */}
//           <Navbar />
//           {/* Page Content */}
//           <div className="page-content container-xxl">
//             {/* Stats Cards Row - UPDATED: 4 BOXES IN ONE ROW */}
//             <div className="row">
//               <div className="col-12 col-xl-12 stretch-card">
//                 <div className="row flex-grow-1">
//                   {/* First Row: 4 Boxes */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">User Details</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5" style={{ width: "100%" }}>

//                             <p style={{ marginBottom: "0px", color: "white" }}>User Id : {userData?.user_code}</p>
//                             <p style={{ marginBottom: "0px", color: "white" }}>Account Name : {userData?.account_name}</p>
//                             <p style={{ marginBottom: "0px", color: "white" }}>Email : {userData?.email}</p>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Plan Details</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5" style={{ width: "100%" }}>
//                             <p style={{ marginBottom: "0px", color: "white" }}>PLan : Awaiting</p>
//                             <p style={{ marginBottom: "0px", color: "white" }}>Rank : Awaiting</p>
//                             <span style={{ marginBottom: "0px", color: "white" }}>Status : </span>
//                             <button
//                               className={userData.user_code ? "status-btn active" : "status-btn inactive"}
//                             >
//                               {userData.user_code ? "Active" : "Inactive"}
//                             </button>

//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/* Box 1: Total Referrals */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Total Referrals</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">{userData?.referral_count}</h3>
//                             <small className="text-muted">Active Referrals</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="referralsChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Box 2: Quantum Main Vault */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Main Vault (Fuel)</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumMainVault.toLocaleString()}</h3>
//                             <small className="text-muted">Fuel Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="mainVaultChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Box 3: Quantum Release */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Release (Withdrawal)</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumRelease.toLocaleString()}</h3>
//                             <small className="text-muted">Withdrawal Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="releaseChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Box 4: Quantum Current */}
//                   <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Current (Liquidity)</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                         <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumCurrent.toLocaleString()}</h3>
//                             <small className="text-muted">Liquidity Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="currentChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                    <div className="col-md-4 grid-margin stretch-card">
//                     <div className="card custom-card">
//                       <div className="top-left"></div>
//                       <div className="top-right"></div>
//                       <div className="bottom-left"></div>
//                       <div className="bottom-right"></div>
//                       <div className="card-body">
//                         <div className="d-flex justify-content-between align-items-baseline">
//                           <h6 className="card-title mb-0">Quantum Qi-Airdrop</h6>
//                           <div className="dropdown mb-2">
//                             <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
//                               <i className="icon-lg text-secondary pb-3px" data-lucide="more-horizontal"></i>
//                             </a>
//                             <div className="dropdown-menu">
//                               {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
//                                 <a key={i} href="#" className="dropdown-item d-flex align-items-center">
//                                   <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
//                                   <span>{action}</span>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                          <div className="row">
//                           <div className="col-6 col-md-12 col-xl-5">
//                             <h3 className="mb-2">${walletData.quantumQiAirdrop.toLocaleString()}</h3>
//                             <small className="text-muted">Airdrop Balance</small>
//                           </div>
//                           <div className="col-6 col-md-12 col-xl-7">
//                             <div id="airdropChart" className="mt-md-3 mt-xl-0"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                 </div>
//               </div>
//             </div>

//             <SponsorLinksTable />


//           </div>

//           {/* Footer */}
//           <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
//             <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
//           </footer>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import { toast } from 'react-toastify'; // Import toast

// Import CSS files
import "../Dashboard Style/core.css";
import "../Dashboard Style/flatpickr.min.css";
import "../assets1/css/custom.css";
import "../assets1/css/style.css";

// Import images
import logo from "../assets1/images/logo.webp";
import usFlag from "../assets1/images/flags/us.svg";
import frFlag from "../assets1/images/flags/fr.svg";
import face2 from "../assets1/images/faces/face2.webp";
import face3 from "../assets1/images/faces/face3.webp";
import face4 from "../assets1/images/faces/face4.webp";
import face5 from "../assets1/images/faces/face5.webp";
import face6 from "../assets1/images/faces/face6.webp";
import qrCodeImage from "../assets/images/qr-code.jpeg";
import { logout, setActiveDate, setPaymentSubmitted, setUserData } from "../Redux/user_information";
import Sidebar from "./Core/Sidebar";
import Navbar from "./Core/Navbar";
import CountdownTimer from "./Dashboard/CountdownTimer";
import {
  registerPaymentApi,
  activateSelfByWalletApi,
  fuelUpMainVaultApi,
  creditFuelWalletPaymentSubmitApi,
  getUserDashboardApi
} from "../Services/Operations/ProductAPI";
import { FaRegCopy } from "react-icons/fa";


const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userDashboardData, setUserDashboardData] = useState(null);
  const [isLoadingUserData, setIsLoadingUserData] = useState(true);
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);
  console.log("userData : ", userData)
  const hasSubmittedPayment = useSelector((state) => state.user?.hasSubmittedPayment);
  const userActiveDate = userData?.active_date;
  const usdtAddress = '0xf22380424e0dfc7170b484d8833dc737d0957c53';


  console.log("authToken : ", authToken);
  console.log("hasSubmittedPayment : ", hasSubmittedPayment);
  console.log("userActiveDate : ", userActiveDate);

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [showActivationPopup, setShowActivationPopup] = useState(false);
  const [transferHash, setTransferHash] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  // State for sidebar and dropdowns
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [openDropdowns, setOpenDropdowns] = useState({});

  console.log("userData : ", userData)

  // State for Fuel Up Modal
  const [showFuelModal, setShowFuelModal] = useState(false);
  const [fuelAmount, setFuelAmount] = useState('');
  const [fuelHash, setFuelHash] = useState('');
  const [isFuelProcessing, setIsFuelProcessing] = useState(false);

  const copyToClipboard = (text, message) => {
    navigator.clipboard.writeText(text);
    toast.success("Address copied to clipboard!")
  };



  useEffect(() => {
    const fetchUserDashboardData = async () => {
      if (!authToken) {
        // If no token, redirect to login
        navigate('/signin');
        return;
      }

      setIsLoadingUserData(true);

      try {
        // Call the dashboard API to get user data
        const result = await getUserDashboardApi(authToken);
        console.log('Dashboard data fetched:', result);

        if (result.data.status === true) {
          console.log('Dashboard data fetched:', result);

          // Store the complete user data from dashboard API
          setUserDashboardData(result.data.data);

          // Update Redux store with complete user data
          dispatch(setUserData({
            userData: {
              ...result.data.data,
              wallets: {
                main_wallet: result.data.data.main_wallet || 0,
                release_wallet: result.data.data.release_wallet || 0,
                current_wallet: result.data.data.current_wallet || 0
              }
            },
            token: authToken, // Keep existing token
            rememberMe: localStorage.getItem('rememberedLoginId') ? true : false
          }));
        } else {
          console.error('Failed to fetch dashboard data:', result.message);

          // Check if token is expired/invalid
          if (result.message?.includes('token') || result.message?.includes('auth') ||
            result.message?.includes('expired') || result.message?.includes('invalid') ||
            result.message?.includes('unauthorized') || result.status === false) {

            // Logout and clear data from Redux
            dispatch(logout());

            // Show error message
            toast.error('Session expired. Please login again.');

            // Redirect to login page
            navigate('/signin');
            return;
          }

          toast.error('Failed to load user data. Please try again.');
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);

        // Check for authentication errors
        if (error.response?.status === 401 || error.message?.includes('token') ||
          error.message?.includes('auth') || error.message?.includes('unauthorized')) {

          // Logout and clear data from Redux
          dispatch(logout());

          toast.error('Session expired. Please login again.');
          navigate('/signin');
          return;
        }

        toast.error('Error loading user data');
      } finally {
        setIsLoadingUserData(false);
      }
    };

    if (authToken) {
      fetchUserDashboardData();
    }
  }, [authToken, dispatch, navigate]);

  const handleFuelUpSubmit = async (e) => {
    e.preventDefault();

    // Validate amount
    const amount = parseFloat(fuelAmount);
    if (isNaN(amount) || amount < 50 || amount > 10000) {
      alert('Please enter a valid amount between $50 and $10,000');
      return;
    }

    if (!fuelHash.trim()) {
      alert('Please enter transaction hash');
      return;
    }

    // Trim and validate hash
    const trimmedHash = fuelHash.trim();
    if (trimmedHash.length < 10) {
      alert('Please enter a valid transaction hash');
      return;
    }



    setIsFuelProcessing(true);

    try {
      // Call the API with correct endpoint
      const result = await creditFuelWalletPaymentSubmitApi(authToken, amount, trimmedHash);

      console.log('Credit Fuel Wallet Result:', result);

      if (result.status === true) {
        // Show success message
        toast.success(
          <div>

            {result.message}<br />

          </div>,
          {
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );

        // Reset form
        setFuelAmount('');
        setFuelHash('');

        // Close modal
        setShowFuelModal(false);

        // Refresh user data to get updated balance (optional)
        // await refreshUserData();

        // If you want to manually update the wallet balance in Redux
        // You can dispatch an action to add the amount to the wallet
        // dispatch(updateMainWalletBalance({
        //   amount: amount,
        //   type: 'credit'
        // }));

      } else {
        // Show error message
        toast.error(result.message || 'Failed to submit credit request');

        // Keep the form data so user can correct it
        // Optionally, you can highlight the error field
      }
    } catch (error) {
      console.error('Error in handleFuelUpSubmit:', error);
      toast.error('Network error. Please check your connection and try again.');
    } finally {
      setIsFuelProcessing(false);
    }
  };
  // Wallet data - using Redux values for first 3, static for last 2
  const walletData = {
    quantumMainVault: userData?.wallets?.main_wallet || 0,
    quantumRelease: userData?.wallets?.release_wallet || 0,
    quantumCurrent: userData?.wallets?.current_wallet || 0,
    quantumQiAirdrop: 0, // Static value
    totalReferrals: userData?.referral_count
  };

  const sponsorLinks = [
    {
      id: 1,
      name: "Sponsor ID",
      link: `https://thewillowquantum.com/register?sponsor_code=${userDashboardData?.sponsor_code}`,
      icon: "user-plus",
      data: userDashboardData?.sponsor_code
    },
    {
      id: 2,
      name: "Position Left",
      link: `https://thewillowquantum.com/register?sponsor_code=${userDashboardData?.sponsor_code}&placement_code=${userDashboardData?.left_position}&position=Left`,
      icon: "arrow-left",
      data: userDashboardData?.left_position
    },
    {
      id: 3,
      name: "Position Right",
      link: `https://thewillowquantum.com/register?sponsor_code=${userDashboardData?.sponsor_code}&placement_code=${userDashboardData?.right_position}&position=Right`,
      icon: "arrow-right",
      data: userDashboardData?.right_position
    }
  ];

  const generateReferralLinks = () => {
    const baseUrl = "https://global.thewillowquantum.com/register";
    const sponsorCode = "WQ13242514"; // This should come from userData

    return {
      sponsorLink: `${baseUrl}?placement_code=${sponsorCode}`,
      positionLeft: `${baseUrl}?placement_code=${sponsorCode}-position-left`,
      positionRight: `${baseUrl}?placement_code=${sponsorCode}-position-right`
    };
  };

  const referralLinks = generateReferralLinks();
  const handleActivateSelfByWallet = async () => {
    try {
      setIsProcessing(true);

      const result = await activateSelfByWalletApi(authToken);

      if (result.status) {
        // Activation successful
        dispatch(setPaymentSubmitted());
        const currentDate = new Date().toISOString().split('T')[0];
        dispatch(setActiveDate(currentDate));
        toast.success(result.message || "Account activated successfully using wallet balance!");
        setShowPaymentPopup(false);
      } else {
        toast.error(result.message || "Activation failed. Please try again.");
      }
    } catch (error) {
      console.error('Error activating by wallet:', error);
      toast.error("Failed to activate account. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };
  // Update the handleWalletSubmit function
  const handleWalletSubmit = (e) => {
    e.preventDefault();

    if (!hasSufficientBalance) {
      toast.error("Insufficient wallet balance. Please add funds.");
      return;
    }

    // Replace window.confirm with custom confirmation using toast
    toast.info(
      <div>
        <p>Confirm registration payment of ${requiredAmount} from your wallet?</p>
        <div className="d-flex justify-content-center gap-2 mt-2">
          <button
            className="btn btn-sm btn-success"
            onClick={() => {
              handleActivateSelfByWallet();
              toast.dismiss();
            }}
          >
            Confirm
          </button>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
      }
    );
  };

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Toggle dropdown
  const toggleDropdown = (dropdownId) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdownId]: !prev[dropdownId]
    }));
  };

  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');

    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }

    // Add custom scrollbar to sidebar body
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  useEffect(() => {
    // Show payment popup only if payment hasn't been submitted
    if (!hasSubmittedPayment) {
      setShowPaymentPopup(true);
    }

    // Show activation popup if active_date is null
    if (!userActiveDate) {
      setShowActivationPopup(true);
    }

    // Initialize all dropdowns as closed by default
    const initialDropdownState = {
      dashboard: false,
      fundManagement: false,
      registrationTeam: false,
      incomeEarnings: false,
      bonanzaRewards: false,
      airdrop: false,
      withdrawal: false,
      settings: false
    };
    setOpenDropdowns(initialDropdownState);
  }, [hasSubmittedPayment, userActiveDate]);

  useEffect(() => {
    // Add custom scrollbar styles
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Custom scrollbar for modal */
      .modal-body {
        max-height: 70vh;
        overflow-y: auto;
      }
      
      .modal-body::-webkit-scrollbar {
        width: 8px;
      }
      
      .modal-body::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      
      .modal-body::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }
      
      .modal-body::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
      
      /* Notification styles */
      .notification {
        animation: slideIn 0.3s ease-out;
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 9999;
        min-width: 300px;
      }
      
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      /* Smooth transitions */
      .sidebar {
        transition: all 0.3s ease;
      }
      
      .modal {
        transition: opacity 0.3s ease;
      }
      
      /* Adjust column width for 4 boxes in a row */
      .col-md-4 {
        width: 25%;
        flex: 0 0 25%;
        max-width: 25%;
      }
      
      /* Single box below takes full width */
      .col-md-12-single {
        width: 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
      
      @media (max-width: 1200px) {
        .col-md-4 {
          width: 50%;
          flex: 0 0 50%;
          max-width: 50%;
        }
      }
      
      @media (max-width: 768px) {
        .col-md-4 {
          width: 100%;
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
      
      /* Sidebar dropdown menu styles */
      .sidebar .nav-dropdown {
        list-style: none;
        padding-left: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }
      
      .sidebar .nav-dropdown.show {
        max-height: 500px;
      }
      
      .sidebar .nav-dropdown-item {
        padding-left: 2.5rem;
      }
      
      /* Sidebar dropdown toggle with icon */
      .nav-item.has-dropdown .nav-link {
        position: relative;
        padding-right: 2.5rem;
      }
      
      .nav-item.has-dropdown .dropdown-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
      }
      
      .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Improved dropdown styling similar to first image */
      .nav-item.has-dropdown .nav-dropdown {
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid var(--primary-color, #0d6efd);
        margin-left: 1rem;
        border-radius: 0 0 8px 8px;
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link {
        padding: 0.75rem 1rem 0.75rem 2rem;
        color: rgba(255, 255, 255, 0.8);
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }
      
      /* Box styling */
      .custom-card {
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;
      }
      
      .custom-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
      }
      
      .custom-card .top-left,
      .custom-card .top-right,
      .custom-card .bottom-left,
      .custom-card .bottom-right {
        position: absolute;
        width: 20px;
        height: 20px;
        border-color: var(--primary-color, #0d6efd);
      }
      
      .custom-card .top-left {
        top: 0;
        left: 0;
        border-top: 2px solid;
        border-left: 2px solid;
      }
      
      .custom-card .top-right {
        top: 0;
        right: 0;
        border-top: 2px solid;
        border-right: 2px solid;
      }
      
      .custom-card .bottom-left {
        bottom: 0;
        left: 0;
        border-bottom: 2px solid;
        border-left: 2px solid;
      }
      
      .custom-card .bottom-right {
        bottom: 0;
        right: 0;
        border-bottom: 2px solid;
        border-right: 2px solid;
      }
      
      /* Fix for category text styling */
      .nav-item.has-dropdown .link-title.nav-item.nav-category {
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      /* Year Planner Table Styles */
      .year-planner-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        font-size: 12px;
      }
      
      .year-planner-table th {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        padding: 8px;
        text-align: center;
        font-weight: 600;
      }
      
      .year-planner-table td {
        border: 1px solid #dee2e6;
        padding: 8px;
        text-align: center;
        height: 40px;
        vertical-align: middle;
      }
      
      .year-planner-table .day-header {
        background-color: #e9ecef;
        font-weight: 600;
        width: 80px;
      }
      
      .year-planner-table .month-header {
        background-color: #0d6efd;
        color: white;
      }
      
      .year-planner-table tr:hover td {
        background-color: #f8f9fa;
      }
      
      /* Referral Links Card Styles */
      .referral-link-card {
        margin-bottom: 10px;
      }
      
      .referral-link-input {
        font-size: 12px;
        font-family: 'Courier New', monospace;
      }
      
      .copy-btn {
        min-width: 70px;
      }
      
      /* Activation Popup Styles */
      .activation-popup {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border-radius: 10px;
        overflow: hidden;
      }
      
      .activation-icon {
        font-size: 4rem;
        color: #ffd700;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // const handleSubmitPayment = async (e) => {
  //   e.preventDefault();

  //   if (!transferHash.trim()) {
  //     toast.error("Please enter transfer hash");
  //     return;
  //   }

  //   setIsProcessing(true);

  //   try {
  //     // Create FormData object
  //     const formData = new FormData();
  //     formData.append('hash_id', transferHash);

  //     const response = await fetch(`https://global.thewillowquantum.com/api/user/register-payment`, {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${authToken}`,
  //         'Accept': 'application/json',
  //       },
  //       body: formData
  //     });

  //     const result = await response.json();

  //     if (response.ok) {
  //       if (result.success) {
  //         // IMPORTANT: Dispatch action to mark payment as submitted
  //         dispatch(setPaymentSubmitted());

  //         toast.success("Payment submitted successfully!");
  //         setTransferHash("");
  //         setShowPaymentPopup(false);

  //         toast.info(`Transaction ID: ${result.transaction_id || result.data?.transactionId || result.id}`);
  //       } else {
  //         toast.error(result.message || "Payment submission failed. Please try again.");
  //       }
  //     } else {
  //       // Handle HTTP errors
  //       if (response.status === 401) {
  //         toast.error("Session expired. Please log in again.");
  //         navigate('/signin');
  //       } else if (response.status === 400) {
  //         toast.error(result.message || "Invalid request. Please check your input.");
  //       } else if (response.status === 422) {
  //         toast.error(result.message || "Validation error. Please check your input.");
  //       } else {
  //         toast.error(result.message || "Server error. Please try again later.");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Payment submission error:", error);
  //     toast.error("Network error. Please check your connection and try again.");
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };
  const handleSubmitPayment = async (e) => {
    e.preventDefault();

    if (!transferHash.trim()) {
      toast.error("Please enter transfer hash");
      return;
    }

    setIsProcessing(true);

    try {
      const result = await registerPaymentApi(authToken, transferHash);

      if (result.status) {
        // IMPORTANT: Dispatch action to mark payment as submitted
        dispatch(setPaymentSubmitted());

        toast.success(result.message || "Payment submitted successfully!");
        setTransferHash("");
        setShowPaymentPopup(false);

        if (result.transactionId) {
          toast.info(`Transaction ID: ${result.transactionId}`);
        }
      } else {
        toast.error(result.message || "Payment submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Payment submission error:", error);
      toast.error(error.message || "An error occurred while processing payment.");
    } finally {
      setIsProcessing(false);
    }
  };
  // const handleCopyToClipboard = (text, label) => {
  //   navigator.clipboard.writeText(text)
  //     .then(() => {
  //       toast.success(`${label} copied to clipboard!`);
  //     })
  //     .catch(err => {
  //       console.error("Failed to copy: ", err);
  //       toast.error("Failed to copy to clipboard");
  //     });
  // };

  // const handleCopyToClipboard = async (text, label) => {
  //   try {
  //     // Try modern Clipboard API first
  //     if (navigator.clipboard && window.isSecureContext) {
  //       await navigator.clipboard.writeText(text);
  //       toast.success(`${label} copied!`);
  //       return;
  //     }
  //   } catch (err) {
  //     console.log("Clipboard API failed, using fallback", err);
  //   }

  //   // Fallback method
  //   fallbackCopy(text, label);
  // };

  const fallbackCopy = (text, label) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Critical styles for mobile
    textArea.style.cssText = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 2em !important;
    height: 2em !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    font-size: 16px !important;
    opacity: 0 !important;
    pointer-events: none !important;
    z-index: 9999 !important;
  `;

    textArea.setAttribute('readonly', '');
    textArea.contentEditable = true;
    textArea.readOnly = false;

    document.body.appendChild(textArea);

    // Different approach for different devices
    const isiOS = /ipad|iphone|ipod/.test(navigator.userAgent.toLowerCase());

    if (isiOS) {
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.focus();
      textArea.select();
    }

    let successful = false;
    try {
      successful = document.execCommand('copy');
    } catch (err) {
      console.error('Copy command failed', err);
    }

    document.body.removeChild(textArea);

    if (successful) {
      toast.success(`${label} copied!`);
    } else {
      toast.error("Failed to copy. Please try again.");
    }
  };



  const handleCopyAddress = () => {
    const address = "0xf22380424e0dfc7170b484d8833dc737d0957c53";
    handleCopyToClipboard(address, "Address");
  };

  const handleClosePopup = () => {
    setShowPaymentPopup(false);
  };

  const handleCloseActivationPopup = () => {
    setShowActivationPopup(false);
  };

  const handleActivateAccount = () => {
    // Here you would make an API call to activate the account
    // For now, we'll just simulate activation
    const currentDate = new Date().toISOString().split('T')[0];

    // Dispatch action to update active_date
    dispatch(setActiveDate(currentDate));

    toast.success("Account activated successfully!");
    setShowActivationPopup(false);

    // In a real app, you would make an API call here
    // Example:
    // fetch(`https://global.thewillowquantum.com/api/user/activate-account`, {
    //   method: 'POST',
    //   headers: {
    //     'Authorization': `Bearer ${authToken}`,
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ activation_date: currentDate })
    // })
  };

  const showNotification = (message, type = "info") => {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification alert alert-${type === 'error' ? 'danger' : type} alert-dismissible fade show`;
    notification.innerHTML = `
      <div class="d-flex align-items-center">
        <i data-lucide="${type === 'success' ? 'check-circle' : type === 'error' ? 'alert-circle' : 'info'}" class="me-2"></i>
        <span>${message}</span>
        <button type="button" class="btn-close ms-auto" data-bs-dismiss="alert"></button>
      </div>
    `;

    // Add to body
    document.body.appendChild(notification);

    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 5000);
  };

  // Year Planner Table Component (as shown in your image)
  const YearPlannerTable = () => {
    const months = ['JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER'];
    const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const rows = 18; // As shown in your image

    return (
      <div className="card custom-card mt-4">
        <div className="top-left"></div>
        <div className="top-right"></div>
        <div className="bottom-left"></div>
        <div className="bottom-right"></div>
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-baseline mb-3">
            <h6 className="card-title mb-0">
              <i className="me-2" data-lucide="calendar"></i>
              YEAR PLANNER
            </h6>
          </div>

          <div className="table-responsive">
            <table className="year-planner-table">
              <thead>
                <tr>
                  <th className="day-header">DAY</th>
                  {months.map((month, index) => (
                    <th key={index} className="month-header">{month}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="day-header">{days[rowIndex % days.length]}</td>
                    {months.map((month, monthIndex) => (
                      <td key={monthIndex}></td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <div className="row">
              <div className="col-md-6">
                <div className="d-flex align-items-center mb-2">
                  <i className="me-2" data-lucide="user" style={{ color: '#0d6efd' }}></i>
                  <span className="fw-bold">Semper Id</span>
                </div>
                <div className="d-flex align-items-center mb-1">
                  <span className="text-muted small me-2">placements - left</span>
                  <i className="me-2" data-lucide="arrow-left" style={{ color: '#28a745' }}></i>
                </div>
                <div className="d-flex align-items-center mb-1">
                  <span className="text-muted small me-2">placement - right</span>
                  <i className="me-2" data-lucide="arrow-right" style={{ color: '#dc3545' }}></i>
                </div>
                <div className="d-flex align-items-center">
                  <span className="text-muted small me-2">p</span>
                  <i className="me-2" data-lucide="circle" style={{ color: '#ffc107' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const SponsorLinksTable = () => {
  //   return (
  //     <div className="card custom-card mt-4">
  //       <div className="top-left"></div>
  //       <div className="top-right"></div>
  //       <div className="bottom-left"></div>
  //       <div className="bottom-right"></div>
  //       <div className="card-body">
  //         <div className="d-flex justify-content-between align-items-baseline mb-3">
  //           <h6 className="card-title mb-0 text-white">
  //             <i className="me-2" data-lucide="link"></i>
  //             Sponsor Links
  //           </h6>
  //         </div>

  //         <div className="table-responsive">
  //           <table className="sponsor-links-table table">
  //             <thead>
  //               <tr className="border-bottom border-secondary">
  //                 <th className="text-white fw-medium" style={{ width: '70%' }}>Link Name</th>
  //                 <th className="text-white fw-medium" style={{ width: '30%' }}>Action</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {sponsorLinks.map((link) => (
  //                 <tr key={link.id} className="border-bottom border-secondary">
  //                   <td className="">
  //                     <div className="sponsor-link-cell d-flex align-items-center">
  //                       <i className={`text-white me-2`} data-lucide={link.icon}></i>
  //                       <span className="fw-medium text-white">{link.name}</span>
  //                       <span className="fw-medium text-white" style={{ marginLeft: "7px" }}>({link.data})</span>
  //                     </div>
  //                   </td>
  //                   <td className="">
  //                     <button
  //                       className="btn btn-outline-light btn-sm copy-btn-small"
  //                       onClick={() => handleCopyToClipboard(link.link, link.name)}
  //                       type="button"
  //                     >
  //                       <MdContentCopy />
  //                     </button>
  //                   </td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
  // COMPONENT - with clean, unique class names
  const SponsorLinksTable = () => {
    return (
      <div className="card  mt-4" style={{
        background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: 'none',
        borderRadius: '0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="top-left"></div>
        <div className="top-right"></div>
        <div className="bottom-left"></div>
        <div className="bottom-right"></div>
        <div className="">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-baseline mb-3">
              <h6 className="card-title mb-0 text-white">
                <i className="me-2" data-lucide="link"></i>
                Sponsor Links
              </h6>
            </div>

            <div className="table-responsive sp-table-responsive"
              style={{
                background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: 'none',
                borderRadius: '0',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <table className="table sp-table"
                style={{
                  background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  boxShadow: 'none',
                  borderRadius: '0',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <thead
                  style={{
                    background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: 'none',
                    borderRadius: '0',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  <tr className="border-bottom border-secondary"
                    style={{
                      background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      boxShadow: 'none',
                      borderRadius: '0',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                  >
                    <th className="text-white fw-medium"
                      style={{
                        background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        boxShadow: 'none',
                        borderRadius: '0',
                        position: 'relative',
                        overflow: 'hidden',
                        width: '30%'
                      }}
                    >Link Name</th>
                    <th className="text-white fw-medium"
                      style={{
                        background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        boxShadow: 'none',
                        borderRadius: '0',
                        position: 'relative',
                        overflow: 'hidden',
                        width: '30%'
                      }}
                    >Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sponsorLinks.map((link) => (
                    <tr key={link.id} className="border-bottom border-secondary sp-row"
                      style={{
                        background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        boxShadow: 'none',
                        borderRadius: '0',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                    >
                      <td className="sp-td"
                        style={{
                          background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          boxShadow: 'none',
                          borderRadius: '0',
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                      >
                        <div className="d-flex align-items-center sp-content"
                          style={{
                            background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            boxShadow: 'none',
                            borderRadius: '0',
                            position: 'relative',
                            overflow: 'hidden'
                          }}
                        >
                          <i className={`text-white me-2`} data-lucide={link.icon}></i>
                          <span className="fw-medium text-white sp-name">{link.name}</span>
                          <span className="fw-medium text-white sp-id">({link.data})</span>
                        </div>
                      </td>
                      <td className="sp-action-td text-end"
                        style={{
                          background: 'radial-gradient(circle, rgba(15, 30, 26, 0.5) 0%, rgba(15, 30, 26, 0.5) 40%, rgba(255, 255, 255, 0.075) 100%)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          boxShadow: 'none',
                          borderRadius: '0',
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                      >
                        <button
                          className="btn btn-sm sp-copy-btn"
                          onClick={() => copyLinkMobile(link.link, link.name)}
                          type="button"
                          data-sp-link={link.link}
                          data-sp-name={link.name}
                          style={{
                            position: "relative",
                            zIndex: "10000000000"
                          }}
                        >
                          <MdContentCopy className="sp-copy-icon" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // SIMPLE GUARANTEED COPY FUNCTION FOR MOBILE
  const copyLinkMobile = (text, label) => {
    console.log("COPY FUNCTION CALLED:", text);

    // METHOD 1: Use Clipboard API if available (modern browsers)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          showToast(`${label} copied!`, 'success');
          console.log("Clipboard API success");
        })
        .catch(err => {
          console.log("Clipboard API failed, trying fallback:", err);
          copyFallback(text, label);
        });
    } else {
      // METHOD 2: Use fallback
      copyFallback(text, label);
    }
  };

  // FALLBACK METHOD - Works on 99% of mobile browsers
  const copyFallback = (text, label) => {
    console.log("Using fallback copy method");

    // Create a DIV instead of textarea (better for mobile)
    const copyDiv = document.createElement('div');
    copyDiv.contentEditable = true;
    copyDiv.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: -9999;
  `;

    // Add text with formatting that helps selection
    copyDiv.innerHTML = `<span style="color: black; font-size: 16px;">${text}</span>`;

    document.body.appendChild(copyDiv);

    // Focus and select
    copyDiv.focus();

    // Create selection range
    const range = document.createRange();
    range.selectNodeContents(copyDiv);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    // Try to copy
    try {
      const successful = document.execCommand('copy');

      if (successful) {
        showToast(`${label} copied!`, 'success');
        console.log("Fallback copy successful");
      } else {
        // If execCommand fails, show manual copy prompt
        showManualCopyPrompt(text, label);
      }
    } catch (err) {
      console.log("execCommand error:", err);
      showManualCopyPrompt(text, label);
    }

    // Clean up
    setTimeout(() => {
      if (document.body.contains(copyDiv)) {
        document.body.removeChild(copyDiv);
      }
      selection.removeAllRanges();
    }, 100);
  };



  // Add CSS animations
  const spStyles = `
  @keyframes spToastSlide {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes spToastSlideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
  
  /* Copy button styles */
  .sp-copy-btn {
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    color: black !important;
    padding: 10px !important;
    border-radius: 6px !important;
    width: 44px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    -webkit-tap-highlight-color: transparent !important;
  }
  
  .sp-copy-btn:active {
    background: rgba(255, 255, 255, 0.3) !important;
    transform: scale(0.95) !important;
  }
  
  .sp-copy-icon {
    font-size: 18px !important;
  }
`;

  // Add styles to document
  useEffect(() => {
    const style = document.createElement('style');
    style.id = 'sp-styles';
    style.textContent = spStyles;
    document.head.appendChild(style);

    return () => {
      const existing = document.getElementById('sp-styles');
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, []);

  // NEW IMPROVED COPY FUNCTION FOR MOBILE
  const handleCopyToClipboardMobile = async (text, label) => {
    console.log('Copying:', text, 'on mobile');

    // Method 1: Try Clipboard API first (modern browsers)
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        showCopySuccess(label);
        return;
      } catch (err) {
        console.log('Clipboard API failed:', err);
      }
    }

    // Method 2: Use a temporary input element (better for mobile)
    const tempInput = document.createElement('input');
    tempInput.value = text;
    tempInput.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 2em;
    height: 2em;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    box-shadow: none;
    background: transparent;
    color: transparent;
    opacity: 0;
    z-index: -9999;
    pointer-events: none;
  `;

    document.body.appendChild(tempInput);

    // For mobile devices, we need to use a different approach
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      // Method for mobile - create a contenteditable div
      const tempDiv = document.createElement('div');
      tempDiv.contentEditable = true;
      tempDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: 0;
      opacity: 0;
      z-index: -9999;
    `;

      // Add text with a span to help selection
      const span = document.createElement('span');
      span.textContent = text;
      tempDiv.appendChild(span);

      document.body.appendChild(tempDiv);

      // Try to select the content
      const range = document.createRange();
      range.selectNodeContents(span);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        // Try to copy using execCommand
        const successful = document.execCommand('copy');

        if (successful) {
          showCopySuccess(label);
        } else {
          // Fallback to prompt method for difficult mobile browsers
          fallbackMobileCopy(text, label);
        }
      } catch (err) {
        console.error('Mobile copy failed:', err);
        fallbackMobileCopy(text, label);
      }

      // Clean up
      selection.removeAllRanges();
      document.body.removeChild(tempDiv);
    } else {
      // Desktop method
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // For mobile

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          showCopySuccess(label);
        } else {
          toast.error("Failed to copy. Please try again.");
        }
      } catch (err) {
        console.error('Copy failed:', err);
        toast.error("Copy not supported in this browser.");
      }
    }

    // Clean up temp input
    document.body.removeChild(tempInput);
  };

  // Fallback method for stubborn mobile browsers
  const fallbackMobileCopy = (text, label) => {
    // Show a prompt with the text pre-selected
    const message = `Copy this ${label}:`;

    // Create a modal/prompt for mobile
    const modal = document.createElement('div');
    modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    padding: 20px;
  `;

    const content = document.createElement('div');
    content.style.cssText = `
    background: white;
    padding: 20px;
    border-radius: 10px;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
  `;

    const title = document.createElement('h5');
    title.textContent = 'Copy to Clipboard';
    title.style.marginBottom = '10px';

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.cssText = `
    width: 100%;
    min-height: 100px;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-family: monospace;
    resize: vertical;
  `;

    const instruction = document.createElement('p');
    instruction.textContent = 'Tap to select all text, then copy manually';
    instruction.style.fontSize = '14px';
    instruction.style.color = '#666';
    instruction.style.marginBottom = '15px';

    const closeBtn = document.createElement('button');
    closeBtn.textContent = 'Close';
    closeBtn.style.cssText = `
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
  `;
    closeBtn.onclick = () => {
      document.body.removeChild(modal);
      toast.info(`Please copy: ${text.substring(0, 30)}...`);
    };

    // Auto-select text for easier copying
    setTimeout(() => {
      textArea.select();
      textArea.setSelectionRange(0, text.length);
    }, 100);

    content.appendChild(title);
    content.appendChild(textArea);
    content.appendChild(instruction);
    content.appendChild(closeBtn);
    modal.appendChild(content);
    document.body.appendChild(modal);

    // Focus the textarea
    textArea.focus();
  };

  const showCopySuccess = (label) => {
    toast.success(`${label} copied!`);

    // Add visual feedback on the button if needed
    const buttons = document.querySelectorAll(`[data-label="${label}"]`);
    buttons.forEach(btn => {
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span style="color: green">✓</span>';
      btn.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';

      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.style.backgroundColor = '';
      }, 1000);
    });
  };

  // Add CSS for better mobile buttons
  const mobileCopyCSS = `
  .copy-btn-mobile {
    min-width: 44px !important;
    min-height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 10px !important;
    -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
    touch-action: manipulation !important;
  }
  
  @media (max-width: 768px) {
    .copy-btn-mobile {
      font-size: 18px !important;
    }
    
    .copy-btn-mobile:active {
      transform: scale(0.95) !important;
      transition: transform 0.1s !important;
    }
  }
`;

  // Add the CSS to the document
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = mobileCopyCSS;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleCopyToClipboard = async (text, label) => {
    try {
      // Try modern Clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        toast.success(`${label} copied!`);
        return;
      }
    } catch (err) {
      console.log("Clipboard API failed, using fallback", err);
    }

    // Use improved mobile-friendly fallback
    fallbackCopyMobile(text, label);
  };

  const fallbackCopyMobile = (text, label) => {
    // Create a more reliable textarea for mobile
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Apply mobile-friendly styles
    textArea.style.cssText = `
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    color: transparent !important;
    opacity: 0 !important;
    z-index: -9999 !important;
    pointer-events: none !important;
    user-select: none !important;
    -webkit-user-select: none !important;
  `;

    // Add to body
    document.body.appendChild(textArea);

    // Focus and select - important for mobile
    textArea.focus();
    textArea.select();

    // For iOS specifically
    if (navigator.userAgent.match(/ipad|iphone|ipod/i)) {
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(textArea);
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    }

    // Execute copy command
    let successful = false;
    try {
      successful = document.execCommand('copy');
    } catch (err) {
      console.error('Copy command failed', err);
    }

    // Clean up
    document.body.removeChild(textArea);

    // Show feedback
    if (successful) {
      toast.success(`${label} copied!`);

      // Add visual feedback on mobile
      const event = new CustomEvent('copySuccess', {
        detail: { label }
      });
      window.dispatchEvent(event);
    } else {
      toast.error("Failed to copy. Please try again.");
    }
  };// UPDATED MANUAL COPY PROMPT - Matching your design
  const showManualCopyPrompt = (text, label) => {
    console.log("Showing manual copy prompt");

    // Create overlay
    const overlay = document.createElement('div');
    overlay.id = 'sp-copy-overlay';
    overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    padding: 20px;
    backdrop-filter: blur(5px);
  `;

    // Create modal matching your design
    const modal = document.createElement('div');
    modal.style.cssText = `
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    padding: 25px;
    border-radius: 15px;
    width: 90%;
    max-width: 450px;
    text-align: center;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
  `;

    // Add decorative corners (like in your design)
    const corners = `
    <div style="
      position: absolute;
      top: 10px;
      left: 10px;
      width: 20px;
      height: 20px;
      border-top: 2px solid #00ffff;
      border-left: 2px solid #00ffff;
      border-radius: 5px 0 0 0;
    "></div>
    <div style="
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      border-top: 2px solid #00ffff;
      border-right: 2px solid #00ffff;
      border-radius: 0 5px 0 0;
    "></div>
    <div style="
      position: absolute;
      bottom: 10px;
      left: 10px;
      width: 20px;
      height: 20px;
      border-bottom: 2px solid #00ffff;
      border-left: 2px solid #00ffff;
      border-radius: 0 0 0 5px;
    "></div>
    <div style="
      position: absolute;
      bottom: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      border-bottom: 2px solid #00ffff;
      border-right: 2px solid #00ffff;
      border-radius: 0 0 5px 0;
    "></div>
  `;

    // Add title
    const title = document.createElement('h5');
    title.textContent = `📋 Copy ${label}`;
    title.style.cssText = `
    margin-bottom: 20px;
    color: #00ffff;
    font-weight: 600;
    font-size: 18px;
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
  `;

    // Add text display box (matching your design)
    const textDisplay = document.createElement('div');
    textDisplay.style.cssText = `
    background: rgba(0, 0, 0, 0.3);
    padding: 15px;
    border-radius: 8px;
    margin: 15px 0;
    border: 1px solid rgba(0, 255, 255, 0.2);
    text-align: left;
    max-height: 150px;
    overflow-y: auto;
    word-break: break-all;
  `;

    const textContent = document.createElement('code');
    textContent.textContent = text;
    textContent.style.cssText = `
    color: #ffffff;
    font-size: 14px;
    font-family: 'Courier New', monospace;
  `;
    textDisplay.appendChild(textContent);

    // Add copyable input (hidden but functional)
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'text';
    hiddenInput.value = text;
    hiddenInput.id = 'copy-input-hidden';
    hiddenInput.style.cssText = `
    position: absolute;
    opacity: 0;
    pointer-events: none;
  `;

    // Add buttons container
    const buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = `
    display: flex;
    gap: 10px;
    margin-top: 20px;
  `;

    // Copy Button
    const copyBtn = document.createElement('button');
    copyBtn.textContent = '📋 Copy Link';
    copyBtn.style.cssText = `
    flex: 1;
    background: linear-gradient(135deg, #00b4d8 0%, #0077b6 100%);
    color: white;
    border: none;
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `;

    copyBtn.onmouseover = () => {
      copyBtn.style.background = 'linear-gradient(135deg, #0096c7 0%, #005f8a 100%)';
      copyBtn.style.transform = 'translateY(-2px)';
    };

    copyBtn.onmouseout = () => {
      copyBtn.style.background = 'linear-gradient(135deg, #00b4d8 0%, #0077b6 100%)';
      copyBtn.style.transform = 'translateY(0)';
    };

    copyBtn.onclick = () => {
      hiddenInput.select();
      hiddenInput.setSelectionRange(0, text.length);

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          // Show success message
          const successMsg = document.createElement('div');
          successMsg.textContent = '✓ Copied!';
          successMsg.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: rgba(40, 167, 69, 0.9);
          color: white;
          padding: 10px 20px;
          border-radius: 20px;
          font-weight: 600;
          z-index: 100;
          animation: fadeInOut 2s ease;
        `;
          modal.appendChild(successMsg);

          // Remove success message after 2 seconds
          setTimeout(() => {
            if (modal.contains(successMsg)) {
              modal.removeChild(successMsg);
            }
          }, 2000);

          // Also try modern clipboard API
          if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
          }
        }
      } catch (err) {
        console.error('Copy failed:', err);
      }
    };

    // Close Button
    const closeBtn = document.createElement('button');
    closeBtn.textContent = '✕ Close';
    closeBtn.style.cssText = `
    flex: 1;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `;

    closeBtn.onmouseover = () => {
      closeBtn.style.background = 'rgba(255, 255, 255, 0.2)';
      closeBtn.style.transform = 'translateY(-2px)';
    };

    closeBtn.onmouseout = () => {
      closeBtn.style.background = 'rgba(255, 255, 255, 0.1)';
      closeBtn.style.transform = 'translateY(0)';
    };

    closeBtn.onclick = () => {
      document.body.removeChild(overlay);
      showToast(`${label} link ready for copy`, 'info');
    };

    // Add instructions
    const instructions = document.createElement('div');
    instructions.innerHTML = `
    <div style="
      margin-top: 15px;
      padding: 10px;
      background: rgba(0, 255, 255, 0.05);
      border-radius: 6px;
      border-left: 3px solid #00ffff;
    ">
      <p style="
        margin: 0;
        color: #88d3ce;
        font-size: 13px;
        text-align: left;
      ">
        <strong>💡 Tip:</strong> Click "Copy Link" or manually select and copy the text above
      </p>
    </div>
  `;

    // Assemble modal
    modal.innerHTML += corners;
    modal.appendChild(title);
    modal.appendChild(textDisplay);
    modal.appendChild(hiddenInput);
    modal.appendChild(instructions);

    buttonsContainer.appendChild(copyBtn);
    buttonsContainer.appendChild(closeBtn);
    modal.appendChild(buttonsContainer);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Auto-select text after modal appears
    setTimeout(() => {
      hiddenInput.select();
      hiddenInput.setSelectionRange(0, text.length);
    }, 300);

    // Focus hidden input
    hiddenInput.focus();

    // Close modal when clicking outside
    overlay.onclick = (e) => {
      if (e.target === overlay) {
        document.body.removeChild(overlay);
      }
    };

    // Close with Escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        document.body.removeChild(overlay);
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);
  };

  // Add CSS for animations
  const modalStyles = `
  @keyframes fadeInOut {
    0% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
    20% { opacity: 1; transform: translate(-50%, -50%) scale(1.1); }
    40% { transform: translate(-50%, -50%) scale(1); }
    80% { opacity: 1; }
    100% { opacity: 0; }
  }
  
  /* Smooth modal appearance */
  #sp-copy-overlay {
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  /* Custom scrollbar for text display */
  #sp-copy-overlay div[style*="overflow-y: auto"]::-webkit-scrollbar {
    width: 6px;
  }
  
  #sp-copy-overlay div[style*="overflow-y: auto"]::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  #sp-copy-overlay div[style*="overflow-y: auto"]::-webkit-scrollbar-thumb {
    background: #00ffff;
    border-radius: 3px;
  }
`;

  // Add modal styles
  useEffect(() => {
    const style = document.createElement('style');
    style.id = 'modal-styles';
    style.textContent = modalStyles;
    document.head.appendChild(style);

    return () => {
      const existing = document.getElementById('modal-styles');
      if (existing) document.head.removeChild(existing);
    };
  }, []);



  // IMPROVED TOAST NOTIFICATION
  const showToast = (message, type = 'success') => {
    // Remove existing toasts
    const existingToasts = document.querySelectorAll('[id^="toast-"]');
    existingToasts.forEach(toast => {
      if (document.body.contains(toast)) {
        document.body.removeChild(toast);
      }
    });

    const toastId = 'toast-' + Date.now();
    const toast = document.createElement('div');
    toast.id = toastId;

    const bgColor = type === 'success' ? '#28a745' :
      type === 'error' ? '#dc3545' :
        type === 'info' ? '#17a2b8' : '#6c757d';

    toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${bgColor};
    color: white;
    padding: 15px 25px;
    border-radius: 10px;
    z-index: 1000000;
    box-shadow: 0 5px 20px rgba(0,0,0,0.3);
    animation: toastSlideIn 0.3s ease;
    max-width: 300px;
    word-wrap: break-word;
    font-weight: 500;
    border-left: 4px solid ${type === 'success' ? '#1e7e34' :
        type === 'error' ? '#bd2130' :
          type === 'info' ? '#138496' : '#545b62'};
  `;

    toast.textContent = message;
    document.body.appendChild(toast);

    // Remove after 3 seconds
    setTimeout(() => {
      const toastEl = document.getElementById(toastId);
      if (toastEl && document.body.contains(toastEl)) {
        toastEl.style.animation = 'toastSlideOut 0.3s ease';
        setTimeout(() => {
          if (toastEl && document.body.contains(toastEl)) {
            document.body.removeChild(toastEl);
          }
        }, 300);
      }
    }, 3000);
  };

  // Add toast animations
  const toastStyles = `
  @keyframes toastSlideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes toastSlideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;

  // Add toast styles
  useEffect(() => {
    const style = document.createElement('style');
    style.id = 'toast-styles';
    style.textContent = toastStyles;
    document.head.appendChild(style);

    return () => {
      const existing = document.getElementById('toast-styles');
      if (existing) document.head.removeChild(existing);
    };
  }, []);

  // Optional: Add visual feedback for mobile users
  if (typeof window !== 'undefined') {
    window.addEventListener('copySuccess', (e) => {
      // You could add a visual effect here if needed
      console.log(`${e.detail.label} copied successfully`);
    });
  }
  const [paymentMethod, setPaymentMethod] = useState('hash'); // 'hash' or 'wallet'
  const currentWalletBalance = userData?.main_wallet || 0;
  const requiredAmount = 5;
  const hasSufficientBalance = currentWalletBalance >= requiredAmount;

  const PaymentPopup = () => {
    // Don't show if payment has been submitted or if user already has active_date
    if (!showPaymentPopup || hasSubmittedPayment || userActiveDate) return null;

    return (
      <div className="modal-backdrop show d-block" style={{
        backgroundColor: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(3px)'
      }}>
        <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title mb-0 d-flex align-items-center">
                  <i className="me-2" data-lucide="credit-card"></i>
                  Registration Payment Required
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={handleClosePopup}
                ></button>
              </div>
              <div className="modal-body p-4">
                {/* Payment Method Toggle */}
                <div className="payment-method-toggle mb-4">
                  <div className="toggle-buttons d-flex bg-light rounded p-1">
                    <button
                      className={`toggle-btn1 flex-fill ${paymentMethod === 'hash' ? 'active' : ''}`}
                      onClick={() => setPaymentMethod('hash')}
                    >
                      <i className="me-2" data-lucide="hash"></i>
                      Active via Hash
                    </button>
                    <button
                      className={`toggle-btn1 flex-fill ${paymentMethod === 'wallet' ? 'active' : ''}`}
                      onClick={() => setPaymentMethod('wallet')}
                    >
                      <i className="me-2" data-lucide="wallet"></i>
                      Active via Wallet
                    </button>
                  </div>
                </div>

                {/* Payment Method Indicator */}
                <div className="alert alert-info mb-4">
                  <div className="d-flex align-items-center">
                    <i className="me-2" data-lucide={paymentMethod === 'hash' ? 'hash' : 'wallet'}></i>
                    <div>
                      <h6 className="mb-1">{paymentMethod === 'hash' ? 'Hash Payment Method' : 'Wallet Payment Method'}</h6>
                      <p className="mb-0 small">
                        {paymentMethod === 'hash'
                          ? 'Submit your transaction hash to verify payment'
                          : 'Use your wallet balance to complete registration'}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Hash Payment Method (Already Done) */}
                {paymentMethod === 'hash' && (
                  <div className="payment-details">
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card border-primary">
                          <div className="card-header bg-primary text-white">
                            <h6 className="mb-0">Registration Fees</h6>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-8">
                                <h5 className="text-primary mb-2">Willow Quantum</h5>
                                <div className="d-flex align-items-center mb-3">
                                  <i className="me-2" data-lucide="coin" style={{ color: '#00a478' }}></i>
                                  <span className="fw-bold">USDT (BEP20)</span>
                                </div>

                                <div className="mb-3">
                                  <label className="form-label text-muted small mb-1">Receiving Address</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control bg-light referral-link-input"
                                      value="0xf22380424e0dfc7170b484d8833dc737d0957c53"
                                      readOnly
                                    />
                                    <button
                                      className="btn btn-outline-primary copy-btn"
                                      onClick={handleCopyAddress}
                                      type="button"
                                    >
                                      <i className="me-1" data-lucide="copy"></i> Copy
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="text-center">
                                  <div className="card bg-light">
                                    <div className="qr-placeholder bg-white rounded">
                                      <img
                                        src={qrCodeImage}
                                        alt="Payment QR Code"
                                        style={{
                                          width: "100%",
                                          objectFit: 'contain'
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <p className="text-muted small mt-2 mb-0">Scan QR Code</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="alert alert-success">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h5 className="mb-1">Fixed Payment Amount</h5>
                              <h2 className="text-dark mb-0">$5 USD</h2>
                            </div>
                            <div className="text-end">
                              <div className="badge bg-primary fs-6">Already Done</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form onSubmit={handleSubmitPayment}>

                      <div className="mb-4">
                        <label htmlFor="transferHash" className="form-label fw-bold">
                          <i className="me-2" data-lucide="hash"></i>
                          Transaction Hash / TXID
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg referral-link-input"
                          id="transferHash"
                          placeholder="Enter your transaction hash"
                          value={transferHash}
                          onChange={(e) => setTransferHash(e.target.value)}
                          required
                        />
                      </div>

                      <div className="d-grid gap-2">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg py-3"
                          disabled={isProcessing}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          {isProcessing ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Processing Payment...
                            </>
                          ) : (
                            <>
                              <i className="me-2" data-lucide="check-circle"></i>
                              Submit Payment Verification
                            </>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {/* Wallet Payment Method */}
                {paymentMethod === 'wallet' && (
                  <div className="wallet-payment-details">
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="alert alert-warning">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h5 className="mb-1">Registration Fees Required</h5>
                              <h2 className="text-dark mb-0">$5 USD</h2>
                            </div>
                            <div className="text-end">
                              <div className="badge bg-warning fs-6">Required Amount</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Current Wallet Balance */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card border-success">
                          <div className="card-header bg-success text-white">
                            <h6 className="mb-0 d-flex align-items-center">
                              <i className="me-2" data-lucide="wallet"></i>
                              Current wallet amount
                            </h6>
                          </div>
                          <div className="card-body">
                            <div className="text-center py-4">
                              <div className="display-1 fw-bold text-success mb-2">
                                ${currentWalletBalance.toFixed(2)}
                              </div>
                              <p className="text-muted mb-0">Available for registration payment</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Balance Status */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className={`balance-status-card ${hasSufficientBalance ? 'bg-success' : 'bg-danger'}`}>
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div className="ms-3">
                                <h6 className="mb-1">
                                  {hasSufficientBalance ? 'Sufficient Balance ✓' : 'Insufficient Balance ✗'}
                                </h6>
                                <p className="mb-0 small">
                                  {hasSufficientBalance
                                    ? `Your wallet has $${currentWalletBalance.toFixed(2)}, which meets the $${requiredAmount} requirement`
                                    : `You need $${(requiredAmount - currentWalletBalance).toFixed(2)} more to proceed`}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Submit Button - Only show if sufficient balance */}
                    {hasSufficientBalance && (
                      <form onSubmit={handleWalletSubmit}>
                        <div className="d-grid gap-2">
                          <button
                            type="submit"
                            className="btn btn-success btn-lg py-3"
                            disabled={isProcessing}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            {isProcessing ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Processing Activation...
                              </>
                            ) : (
                              <>
                                <i className="me-2" data-lucide="check-circle"></i>
                                Activate Account via Wallet
                              </>
                            )}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  const [isMobile, setIsMobile] = useState(false);

  // Check screen size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);

      // Auto-close sidebar on mobile by default
      if (mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(true);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);



  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <>
      {/* <PaymentPopup /> */}

      <div className="main-wrapper">
        {/* Sidebar */}
        <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
          <div className="sidebar-header">
            <a href="#" className="sidebar-brand">
              <i className="me-2" data-lucide="atom"></i>
              Willow <span>Quantum</span>
            </a>
            <div className="sidebar-toggler" onClick={toggleSidebar}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <Sidebar
            isOpen={!sidebarOpen}
            onClose={closeSidebar}
          />

          {/* Mobile backdrop */}
          {isMobile && sidebarOpen && (
            <div
              className="sidebar-backdrop"
              onClick={closeSidebar}
            />
          )}
        </nav>
        <div className={`page-wrapper ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
          {/* Navbar */}
          <Navbar
            toggleSidebar={toggleSidebar}
            isSidebarOpen={sidebarOpen}
            isMobile={isMobile}
          />



          <div className="page-content container-xxl">
            {/* Stats Cards Row - UPDATED: 4 BOXES IN ONE ROW */}
            <div className="row flex-grow-1">
              {/* First Row: 4 Boxes */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="card-title mb-0">User Details</h6>
                      <div className="dropdown mb-0">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <p style={{ marginBottom: "0px", color: "white" }}>User Id : {userData?.user_code}</p>
                      <p style={{ marginBottom: "0px", color: "white" }}>Account Name : {userData?.account_name}</p>
                      <p style={{ marginBottom: "0px", color: "white" }}>Email : {userData?.email}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="card-title mb-0">Plan Details</h6>
                      <div className="dropdown mb-0">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <p style={{ marginBottom: "0px", color: "white" }}>Plan :   <div className="plan-badge" style={{
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                          padding: "8px 16px",
                          borderRadius: "12px",
                          fontWeight: "600",

                          display: "inline-block",
                          boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)"
                        }}>
                          {userData?.plan_name}
                        </div></p>

                        {/* Upgrade Button */}
                        <div className="">
                          <button
                            className="btn btn-success btn-sm d-flex align-items-center"
                            onClick={() => navigate('/upgrade-plan')}
                            style={{
                              padding: "8px 16px",
                              fontSize: "14px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              background: "linear-gradient(135deg, #00b09b 0%, #96c93d 100%)",
                              border: "none",
                              boxShadow: "0 4px 10px rgba(0, 176, 155, 0.3)"
                            }}
                          >
                            <i className="me-1" data-lucide="arrow-up-circle"></i>
                            Upgrade Plan
                          </button>
                        </div>
                      </div>
                      <p style={{ marginBottom: "0px", color: "white" }}>Plan Amount : ${userData?.plan_amount}</p>
                      <p style={{ marginBottom: "0px", color: "white" }}>Rank : Awaiting</p>

                      <div className="d-flex align-items-center gap-2 mb-2">
                        <span style={{ marginBottom: "0px", color: "white" }}>Status : </span>
                        <button className={userData.user_code ? "status-btn active" : "status-btn inactive"}>
                          {userData.user_code ? "Active" : "Inactive"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 1: Total Referrals */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Total Referrals</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <h3 className="mb-2">{userData?.referral_count}</h3>
                      <small className="text-muted">Active Referrals</small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 2: Quantum Main Vault */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Quantum Main Vault (Fuel)</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <h3 className="mb-2">${walletData.quantumMainVault.toLocaleString()}</h3>
                      <div className="mt-3">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => setShowFuelModal(true)}
                          style={{
                            padding: "8px 16px",
                            fontSize: "14px"
                          }}
                        >
                          <i className="me-1" data-lucide="fuel"></i>
                          Fuel Up Main Vault
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Fuel Up Modal Component */}
              {showFuelModal && (
                <div className="modal-backdrop show d-block" style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.85)',
                  backdropFilter: 'blur(8px)',
                  animation: 'fadeIn 0.3s ease'
                }}>
                  <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                      <div className="modal-content border-0 shadow-5xl" style={{
                        background: 'linear-gradient(145deg, #0f172a 0%, #1e293b 100%)',
                        borderRadius: '20px',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        overflow: 'hidden'
                      }}>
                        {/* Modal Header */}
                        <div className="modal-header border-0 pb-0" style={{
                          background: 'linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%)',
                          padding: '1.5rem'
                        }}>
                          <div className="d-flex align-items-center w-100">
                            <div className="flex-grow-1">
                              <h5 className="modal-title mb-0 text-white fw-bold d-flex align-items-center">
                                <div className="fuel-icon-container me-3" style={{
                                  background: 'rgba(255, 255, 255, 0.2)',
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '12px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <i className="bi bi-fuel-pump-fill text-white" style={{ fontSize: '1.2rem' }}></i>
                                </div>
                                Fuel Up Main Vault
                              </h5>
                              <p className="text-white-50 mb-0 mt-1" style={{ fontSize: '0.875rem' }}>
                                Add funds to your main vault securely
                              </p>
                            </div>
                            <button
                              type="button"
                              className="btn-close btn-close-white"
                              onClick={() => setShowFuelModal(false)}
                              style={{
                                filter: 'brightness(0) invert(1)',
                                opacity: '0.8'
                              }}
                            ></button>
                          </div>
                        </div>

                        <div className="modal-body p-4">
                          {/* QR Code Section */}
                          <div className="row mb-4">
                            <div className="col-12">
                              <div className="qr-section text-center mb-4">
                                <div className="qr-container mx-auto" style={{
                                  maxWidth: '200px',
                                  background: 'white',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
                                  position: 'relative'
                                }}>
                                  <img
                                    src={qrCodeImage}
                                    alt="Payment QR Code"
                                    style={{
                                      width: '100%',
                                      height: 'auto',
                                      objectFit: 'contain',
                                      borderRadius: '8px'
                                    }}
                                  />

                                </div>
                                <div
                                  className="mt-3 d-flex align-items-center justify-content-center gap-2"
                                  style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    padding: '10px 16px',
                                    borderRadius: '100px',
                                    border: '1px solid rgba(59, 130, 246, 0.3)',
                                    maxWidth: '490px',
                                    margin: '15px auto 0',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: 'monospace',
                                      fontSize: '0.85rem',
                                      color: '#a0aec0',
                                      wordBreak: 'break-all',
                                    }}
                                  >
                                    USDT BEP20: {usdtAddress}
                                  </span>
                                  <button
                                    type="button"
                                    onClick={() => copyToClipboard(usdtAddress, 'Address copied!')}
                                    style={{
                                      background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                                      border: 'none',
                                      color: 'white',
                                      width: '36px',
                                      height: '36px',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      cursor: 'pointer',
                                      transition: 'transform 0.2s',
                                      boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                                      flexShrink: 0,
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.transform = 'scale(1.1)')
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.transform = 'scale(1)')
                                    }
                                  >
                                    <FaRegCopy />
                                  </button>
                                </div>

                              </div>
                            </div>
                          </div>


                          {/* Amount Range Card */}
                          <div className="row mb-4">
                            <div className="col-12">
                              <div className="amount-range-card" style={{
                                background: 'rgba(59, 130, 246, 0.1)',
                                border: '1px solid rgba(59, 130, 246, 0.2)',
                                borderRadius: '15px',
                                padding: '20px',
                                position: 'relative',
                                overflow: 'hidden'
                              }}>
                                <div className="range-overlay" style={{
                                  position: 'absolute',
                                  top: '0',
                                  right: '0',
                                  width: '100px',
                                  height: '100px',
                                  background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%)',
                                  transform: 'translate(30px, -30px)'
                                }}></div>

                                <div className="row align-items-center">
                                  <div className="col-md-8">
                                    <h6 className="text-primary mb-2" style={{ fontWeight: '600' }}>
                                      <i className="bi bi-sliders me-2"></i>
                                      Fuel Up Amount Range
                                    </h6>
                                    <h2 className="mb-0" style={{
                                      background: 'linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%)',
                                      WebkitBackgroundClip: 'text',
                                      WebkitTextFillColor: 'transparent',
                                      fontWeight: '700'
                                    }}>
                                      $50 - $10,000 USD
                                    </h2>
                                  </div>
                                  <div className="col-md-4 text-md-end mt-3 mt-md-0">
                                    <div className="badge" style={{
                                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                      color: 'white',
                                      fontSize: '0.9rem',
                                      padding: '8px 16px',
                                      borderRadius: '25px',
                                      fontWeight: '600'
                                    }}>
                                      <i className="bi bi-shield-check me-1"></i>
                                      Minimum $50
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Fuel Up Form */}
                          <form onSubmit={handleFuelUpSubmit}>
                            {/* Amount Input */}
                            <div className="mb-4">
                              <label className="form-label fw-semibold text-white mb-3 d-flex align-items-center">
                                <div className="icon-container me-2" style={{
                                  background: 'rgba(59, 130, 246, 0.2)',
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <i className="bi bi-currency-dollar text-primary"></i>
                                </div>
                                Amount to Fuel (USD)
                              </label>
                              <div className="input-group input-group-lg mb-2">
                                <span className="input-group-text" style={{
                                  background: 'rgba(255, 255, 255, 0.05)',
                                  border: '1px solid rgba(255, 255, 255, 0.1)',
                                  color: '#3b82f6',
                                  fontWeight: '600',
                                  fontSize: '1.1rem'
                                }}>
                                  $
                                </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter amount from $50 to $10,000"
                                  min="50"
                                  max="10000"
                                  step="0.01"
                                  value={fuelAmount}
                                  onChange={(e) => setFuelAmount(e.target.value)}
                                  required
                                  style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    color: 'white',
                                    fontSize: '1.1rem'
                                  }}
                                />
                                <span className="input-group-text" style={{
                                  background: 'rgba(255, 255, 255, 0.05)',
                                  border: '1px solid rgba(255, 255, 255, 0.1)',
                                  color: 'rgba(255, 255, 255, 0.6)',
                                  fontSize: '0.9rem'
                                }}>
                                  USD
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mt-2">
                                <small className="text-muted">
                                  <i className="bi bi-arrow-down-circle me-1"></i>
                                  Min: $50.00
                                </small>
                                <small className="text-muted">
                                  <i className="bi bi-arrow-up-circle me-1"></i>
                                  Max: $10,000.00
                                </small>
                              </div>
                            </div>

                            {/* Transaction Hash Input with Copy Button */}
                            <div className="mb-4">
                              <label className="form-label fw-semibold text-white mb-3 d-flex align-items-center">
                                <div className="icon-container me-2" style={{
                                  background: 'rgba(16, 185, 129, 0.2)',
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <i className="bi bi-hash text-success"></i>
                                </div>
                                Transaction Hash / TXID
                              </label>
                              <div className="input-group input-group-lg mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Paste your transaction hash here"
                                  value={fuelHash}
                                  onChange={(e) => setFuelHash(e.target.value)}
                                  required
                                  style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    color: 'white',
                                    fontSize: '0.95rem',
                                    fontFamily: 'monospace'
                                  }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={() => {
                                    navigator.clipboard.writeText(fuelHash);
                                    toast.success('Transaction hash copied!');
                                  }}
                                  disabled={!fuelHash}
                                  style={{
                                    borderColor: 'rgba(59, 130, 246, 0.3)',
                                    color: '#3b82f6',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                  }}
                                >
                                  <i className="bi bi-copy"></i>
                                  Copy
                                </button>
                              </div>
                              <small className="text-muted d-flex align-items-center">
                                <i className="bi bi-info-circle me-2"></i>
                                Enter the transaction hash from your USDT transfer
                              </small>
                            </div>

                            {/* Current Balance Display */}
                            <div className="row mb-4">
                              <div className="col-12">
                                <div className="balance-card" style={{
                                  background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%)',
                                  border: '1px solid rgba(16, 185, 129, 0.2)',
                                  borderRadius: '15px',
                                  padding: '20px',
                                  position: 'relative',
                                  overflow: 'hidden'
                                }}>
                                  <div className="balance-overlay" style={{
                                    position: 'absolute',
                                    top: '-20px',
                                    right: '-20px',
                                    width: '100px',
                                    height: '100px',
                                    background: 'radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, transparent 70%)'
                                  }}></div>

                                  <div className="text-center">
                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                      <i className="bi bi-vault-fill text-success me-2" style={{ fontSize: '1.5rem' }}></i>
                                      <h6 className="mb-0 text-success fw-semibold">Current Main Vault Balance</h6>
                                    </div>
                                    <div className="display-4 fw-bold text-white mb-2" style={{
                                      textShadow: '0 2px 10px rgba(16, 185, 129, 0.3)'
                                    }}>
                                      ${parseFloat(walletData.quantumMainVault || 0).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </div>
                                    <div className="balance-projection" style={{
                                      background: 'rgba(16, 185, 129, 0.15)',
                                      padding: '10px 20px',
                                      borderRadius: '10px',
                                      display: 'inline-block',
                                      marginTop: '10px'
                                    }}>
                                      <span className="text-success-300 fw-medium">
                                        After fueling:&nbsp;
                                        <span className="text-white fw-bold">
                                          $
                                          {(parseFloat(walletData.quantumMainVault || 0) + parseFloat(fuelAmount || 0))
                                            .toLocaleString('en-US', {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            })}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="d-grid gap-3">
                              <button
                                type="submit"
                                className="btn btn-lg py-3 fw-bold"
                                disabled={isFuelProcessing || !fuelAmount || parseFloat(fuelAmount) < 50 || parseFloat(fuelAmount) > 10000 || !fuelHash}
                                style={{
                                  background: 'linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%)',
                                  border: 'none',
                                  color: 'white',
                                  borderRadius: '12px',
                                  fontSize: '1.1rem',
                                  transition: 'all 0.3s ease',
                                  position: 'relative',
                                  overflow: 'hidden'
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.transform = 'translateY(-2px)';
                                  e.target.style.boxShadow = '0 10px 25px rgba(59, 130, 246, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.transform = 'translateY(0)';
                                  e.target.style.boxShadow = 'none';
                                }}
                              >
                                {isFuelProcessing ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Processing Fuel Up...
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-lightning-charge-fill me-2"></i>
                                    Fuel Up Main Vault
                                  </>
                                )}
                              </button>

                              <button
                                type="button"
                                className="btn btn-outline-light btn-lg py-2"
                                onClick={() => setShowFuelModal(false)}
                                style={{
                                  borderRadius: '12px',
                                  borderColor: 'rgba(255, 255, 255, 0.2)',
                                  fontWeight: '500'
                                }}
                              >
                                Cancel
                              </button>
                            </div>

                            {/* Security Note */}
                            <div className="text-center mt-4">
                              <div className="security-note" style={{
                                background: 'rgba(255, 255, 255, 0.03)',
                                padding: '12px',
                                borderRadius: '10px',
                                borderLeft: '3px solid #3b82f6'
                              }}>
                                <small className="text-muted d-flex align-items-center justify-content-center">
                                  <i className="bi bi-shield-check me-2 text-primary"></i>
                                  Secure transaction • Funds processed within 5-10 minutes
                                </small>
                              </div>
                            </div>
                          </form>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer border-top-0 mt-3" style={{
                          background: 'rgba(0, 0, 0, 0.2)',
                          padding: '15px 1.5rem'
                        }}>
                          <div className="w-100 text-center">
                            <small className="text-muted d-flex align-items-center justify-content-center">
                              <i className="bi bi-info-circle me-2"></i>
                              Ensure you're sending USDT (TRC20) only. Other tokens will be lost.
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Box 3: Quantum Release */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Quantum Release (Withdrawal)</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <h3 className="mb-2">${walletData.quantumRelease.toLocaleString()}</h3>
                      <small className="text-muted">Withdrawal Balance</small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 4: Quantum Current */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Quantum Current (Liquidity)</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <h3 className="mb-2">${walletData.quantumCurrent.toLocaleString()}</h3>
                      <small className="text-muted">Liquidity Balance</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Quantum Qi-Airdrop</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <h3 className="mb-2">${walletData.quantumQiAirdrop.toLocaleString()}</h3>
                      <small className="text-muted">Airdrop Balance</small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 1: Total Team */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="card-title mb-0">Total Team</h6>
                        <span className="badge bg-primary">
                          {(userDashboardData?.total_team?.active || 0) + (userDashboardData?.total_team?.inactive || 0)}
                        </span>
                      </div>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-check" style={{ color: '#28a745' }}></i>
                              <h3 className="mb-0">{userDashboardData?.total_team?.active || 0}</h3>
                            </div>
                            <span className="text-success small fw-bold">Active</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-x" style={{ color: '#dc3545' }}></i>
                              <h3 className="mb-0">{userDashboardData?.total_team?.inactive || 0}</h3>
                            </div>
                            <span className="text-danger small fw-bold">Inactive</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 2: Total Right Side */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="card-title mb-0">Total Right Side</h6>
                        <span className="badge bg-primary">
                          {(userDashboardData?.total_right_side?.active || 0) + (userDashboardData?.total_right_side?.inactive || 0)}
                        </span>
                      </div>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-check" style={{ color: '#28a745' }}></i>
                              <h3 className="mb-0">{userDashboardData?.total_right_side?.active || 0}</h3>
                            </div>
                            <span className="text-success small fw-bold">Active</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-x" style={{ color: '#dc3545' }}></i>
                              <h3 className="mb-0">{userDashboardData?.total_right_side?.inactive || 0}</h3>
                            </div>
                            <span className="text-danger small fw-bold">Inactive</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 3: Total Left Side */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="card-title mb-0">Total Left Side</h6>
                        <span className="badge bg-primary">
                          {(userDashboardData?.total_left_side?.active || 0) + (userDashboardData?.total_left_side?.inactive || 0)}
                        </span>
                      </div>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-check" style={{ color: '#28a745' }}></i>
                              <h3 className="mb-0">{userDashboardData?.total_left_side?.active || 0}</h3>
                            </div>
                            <span className="text-success small fw-bold">Active</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-x" style={{ color: '#dc3545' }}></i>
                              <h3 className="mb-0">{userDashboardData?.total_left_side?.inactive || 0}</h3>
                            </div>
                            <span className="text-danger small fw-bold">Inactive</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 4: Right Side Direct */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="card-title mb-0">Right side direct</h6>
                        <span className="badge bg-primary">
                          {(userDashboardData?.right_side_team?.active || 0) + (userDashboardData?.right_side_team?.inactive || 0)}
                        </span>
                      </div>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-check" style={{ color: '#28a745' }}></i>
                              <h3 className="mb-0">{userDashboardData?.right_side_team?.active || 0}</h3>
                            </div>
                            <span className="text-success small fw-bold">Active</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-x" style={{ color: '#dc3545' }}></i>
                              <h3 className="mb-0">{userDashboardData?.right_side_team?.inactive || 0}</h3>
                            </div>
                            <span className="text-danger small fw-bold">Inactive</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 5: Left Side Direct */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="card-title mb-0">Left side direct</h6>
                        <span className="badge bg-primary">
                          {(userDashboardData?.left_side_team?.active || 0) + (userDashboardData?.left_side_team?.inactive || 0)}
                        </span>
                      </div>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-check" style={{ color: '#28a745' }}></i>
                              <h3 className="mb-0">{userDashboardData?.left_side_team?.active || 0}</h3>
                            </div>
                            <span className="text-success small fw-bold">Active</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center mb-2">
                              <i className="me-2" data-lucide="user-x" style={{ color: '#dc3545' }}></i>
                              <h3 className="mb-0">{userDashboardData?.left_side_team?.inactive || 0}</h3>
                            </div>
                            <span className="text-danger small fw-bold">Inactive</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Box 1: Total Volume */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Total Volume</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="d-flex align-items-center justify-content-center mb-2">
                        <i className="me-2" data-lucide="trending-up" style={{ color: '#28a745' }}></i>
                        <h3 className="mb-0">${userDashboardData?.total_volume?.toLocaleString() || 0}</h3>
                      </div>
                      {/* <small className="text-muted">Overall Volume</small> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 2: Left Volume */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Left Volume</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="d-flex align-items-center justify-content-center mb-2">
                        <i className="me-2" data-lucide="arrow-left" style={{ color: '#2196f3' }}></i>
                        <h3 className="mb-0">${userDashboardData?.left_volume?.toLocaleString() || 0}</h3>
                      </div>
                      {/* <small className="text-muted">Left Side Volume</small> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 3: Right Volume */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Right Volume</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="d-flex align-items-center justify-content-center mb-2">
                        <i className="me-2" data-lucide="arrow-right" style={{ color: '#9c27b0' }}></i>
                        <h3 className="mb-0">${userDashboardData?.right_volume?.toLocaleString() || 0}</h3>
                      </div>
                      {/* <small className="text-muted">Right Side Volume</small> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Box 4: Today's Income */}
              <div className="col-md-4 stretch-card">
                <div className="card custom-card">
                  <div className="top-left"></div>
                  <div className="top-right"></div>
                  <div className="bottom-left"></div>
                  <div className="bottom-right"></div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-baseline">
                      <h6 className="card-title mb-0">Today's Income</h6>
                      <div className="dropdown mb-2">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lucide="more-horizontal" className="lucide lucide-more-horizontal icon-lg text-secondary pb-3px"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                        </a>
                        <div className="dropdown-menu">
                          {["View", "Edit", "Delete", "Print", "Download"].map((action, i) => (
                            <a key={i} href="#" className="dropdown-item d-flex align-items-center">
                              <i data-lucide={action.toLowerCase()} className="icon-sm me-2"></i>
                              <span>{action}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="d-flex align-items-center justify-content-center mb-2">
                        <i className="me-2" data-lucide="dollar-sign" style={{ color: '#ff9800' }}></i>
                        <h3 className="mb-0">${userDashboardData?.today_income?.toLocaleString() || 0}</h3>
                      </div>
                      {/* <small className="text-muted">Daily Earnings</small> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-xl-12 stretch-card">
                <SponsorLinksTable />
              </div>
            </div>
          </div>

          {/* Footer */}
          <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
            <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Dashboard;